/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkJobPostingCreateInputRequest,
  BulkJobPostingCreateResponse,
  CandidateInterviewRetrieveResponse,
  CandidateReview,
  CandidateReviewRequest,
  ExperienceLevel,
  ExtendedInterviewManager,
  HireCandidateInterviewsListParams,
  HireCandidateInterviewsPastListParams,
  HireCandidateInterviewsPendingListParams,
  HireCandidateInterviewsUnratedListParams,
  HireCandidateInterviewsUpcomingListParams,
  HireCandidateScreeningInterviewsListParams,
  HireCandidateScreeningInterviewsPendingListParams,
  HireCandidatesListParams,
  HireInterviewsHiringScheduleListParams,
  HireInterviewsHistoryListParams,
  HireInterviewsListParams,
  HireInterviewsPayDueListParams,
  HireInterviewsUpcomingListParams,
  HireJobsDestroyParams,
  HireJobsListParams,
  HireJobsLookupByLinkRetrieveParams,
  HireJobsProMatchStatusListParams,
  HireJobsPublishCreate400,
  HireJobsSkillsListParams,
  HireManagerAvailabilityWeekPreviewListParams,
  HireScreeningInterviewsListParams,
  HireStafferInterviewsHiringScheduleListParams,
  HireStafferInterviewsHistoryListParams,
  HireStafferInterviewsListParams,
  HireStafferInterviewsPayDueListParams,
  HireStafferInterviewsUpcomingListParams,
  HireStafferScreeningInterviewsListParams,
  HireUser,
  HireUserRequest,
  HiringScheduleItem,
  Interview,
  InterviewDTO,
  InterviewDTORequest,
  InterviewFeedbackRequest,
  JobPosting,
  JobPostingRequest,
  JobPostingResponse,
  JobPostingResponseWithApplicationDate,
  JobPostingSkill,
  ManagerAvailabilityJobCounts,
  ManagerAvailabilityScope,
  ManagerAvailabilityWindow,
  ManagerAvailabilityWindowRequest,
  NotFoundError,
  PaginatedCandidateList,
  PaginatedInterviewList,
  PaginatedInterviewManagerList,
  PaginatedInterviewSerializerForCandidateRetrieveList,
  PaginatedJobPostingResponseList,
  PaginatedScreeningInterviewList,
  PaginatedScreeningInterviewManagerList,
  PatchedHireUserRequest,
  PatchedInterviewFeedbackRequest,
  PatchedJobPostingRequest,
  PatchedScreeningInterviewFeedbackRequest,
  PatchedScreeningInterviewRescheduleRequest,
  PermissionDeniedError,
  PhoneNumberLookupResponse,
  ProMatchStatusResult,
  PublishJobPostingRequest,
  ScrapeByUrlInputRequest,
  ScrapeByUrlResponse,
  ScreeningInterview,
  ScreeningInterviewCreateRequest,
  ScreeningInterviewFeedbackRequest,
  ScreeningInterviewManager,
  ScreeningInterviewRetrieve,
  StafferReview,
  StafferReviewRequest,
  UnauthenticatedError
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHireCandidateInterviewsListUrl = (params?: HireCandidateInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/interviews/?${stringifiedParams}` : `/api/hire/candidate/interviews/`
}

export const hireCandidateInterviewsList = async (params?: HireCandidateInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewList> => {

  return customFetch<PaginatedInterviewList>(getHireCandidateInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsListInfiniteQueryKey = (params?: HireCandidateInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/candidate/interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateInterviewsListQueryKey = (params?: HireCandidateInterviewsListParams,) => {
    return [
    `/api/hire/candidate/interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, HireCandidateInterviewsListParams['page']>, TError = void>(params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, QueryKey, HireCandidateInterviewsListParams['page']> = ({ signal, pageParam }) => hireCandidateInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsList>>>
export type HireCandidateInterviewsListInfiniteQueryError = void


export function useHireCandidateInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, HireCandidateInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireCandidateInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, HireCandidateInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, HireCandidateInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, HireCandidateInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData, QueryKey, HireCandidateInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError = void>(params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsList>>> = ({ signal }) => hireCandidateInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsList>>>
export type HireCandidateInterviewsListQueryError = void


export function useHireCandidateInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError = void>(
 params: undefined |  HireCandidateInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError = void>(
 params?: HireCandidateInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsReviewsCreateUrl = (interviewId: string,) => {




  return `/api/hire/candidate/interviews/${interviewId}/reviews/`
}

export const hireCandidateInterviewsReviewsCreate = async (interviewId: string,
    candidateReviewRequest: CandidateReviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<CandidateReview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CandidateReview>(getHireCandidateInterviewsReviewsCreateUrl(interviewId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(candidateReviewRequest)
  }
);}





export const getHireCandidateInterviewsReviewsCreateMutationKey = () => ['hireCandidateInterviewsReviewsCreate'] as const;

export const getHireCandidateInterviewsReviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>, TError,HireCandidateInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>, TError,HireCandidateInterviewsReviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireCandidateInterviewsReviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>, HireCandidateInterviewsReviewsCreateMutationVariables> = (props) => {
          const {interviewId,data} = props ?? {};

          return  hireCandidateInterviewsReviewsCreate(interviewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireCandidateInterviewsReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>>
    export type HireCandidateInterviewsReviewsCreateMutationBody = CandidateReviewRequest
    export type HireCandidateInterviewsReviewsCreateMutationError = void
    export type HireCandidateInterviewsReviewsCreateMutationVariables = {interviewId: string;data: CandidateReviewRequest}

    export const useHireCandidateInterviewsReviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>, TError,HireCandidateInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireCandidateInterviewsReviewsCreate>>,
        TError,
        HireCandidateInterviewsReviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireCandidateInterviewsReviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireCandidateInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/candidate/interviews/${id}/`
}

export const hireCandidateInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<CandidateInterviewRetrieveResponse> => {

  return customFetch<CandidateInterviewRetrieveResponse>(getHireCandidateInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/candidate/interviews/${id}/`
    ] as const;
    }


export const getHireCandidateInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>> = ({ signal }) => hireCandidateInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>>
export type HireCandidateInterviewsRetrieveQueryError = void


export function useHireCandidateInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsConfirmationsCreateUrl = (id: string,) => {




  return `/api/hire/candidate/interviews/${id}/confirmations/`
}

export const hireCandidateInterviewsConfirmationsCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Interview> => {

  return customFetch<Interview>(getHireCandidateInterviewsConfirmationsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireCandidateInterviewsConfirmationsCreateMutationKey = () => ['hireCandidateInterviewsConfirmationsCreate'] as const;

export const getHireCandidateInterviewsConfirmationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>, TError,HireCandidateInterviewsConfirmationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>, TError,HireCandidateInterviewsConfirmationsCreateMutationVariables, TContext> => {

const mutationKey = getHireCandidateInterviewsConfirmationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>, HireCandidateInterviewsConfirmationsCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireCandidateInterviewsConfirmationsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireCandidateInterviewsConfirmationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>>

    export type HireCandidateInterviewsConfirmationsCreateMutationError = void
    export type HireCandidateInterviewsConfirmationsCreateMutationVariables = {id: string}

    export const useHireCandidateInterviewsConfirmationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>, TError,HireCandidateInterviewsConfirmationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireCandidateInterviewsConfirmationsCreate>>,
        TError,
        HireCandidateInterviewsConfirmationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireCandidateInterviewsConfirmationsCreateMutationOptions(options), queryClient);
    }
    export const getHireCandidateInterviewsPhoneNumberLookupRetrieveUrl = (id: string,
    phoneNumber: string,) => {




  return `/api/hire/candidate/interviews/${id}/phone-number-lookup/${phoneNumber}/`
}

export const hireCandidateInterviewsPhoneNumberLookupRetrieve = async (id: string,
    phoneNumber: string, options?: Parameters<typeof customFetch>[1]): Promise<PhoneNumberLookupResponse> => {

  return customFetch<PhoneNumberLookupResponse>(getHireCandidateInterviewsPhoneNumberLookupRetrieveUrl(id,phoneNumber),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsPhoneNumberLookupRetrieveQueryKey = (id: string,
    phoneNumber: string,) => {
    return [
    `/api/hire/candidate/interviews/${id}/phone-number-lookup/${phoneNumber}/`
    ] as const;
    }


export const getHireCandidateInterviewsPhoneNumberLookupRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError = void>(id: string,
    phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsPhoneNumberLookupRetrieveQueryKey(id,phoneNumber);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>> = ({ signal }) => hireCandidateInterviewsPhoneNumberLookupRetrieve(id,phoneNumber, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && phoneNumber !== null && phoneNumber !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsPhoneNumberLookupRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>>
export type HireCandidateInterviewsPhoneNumberLookupRetrieveQueryError = void


export function useHireCandidateInterviewsPhoneNumberLookupRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError = void>(
 id: string,
    phoneNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPhoneNumberLookupRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError = void>(
 id: string,
    phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPhoneNumberLookupRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError = void>(
 id: string,
    phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsPhoneNumberLookupRetrieve<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError = void>(
 id: string,
    phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPhoneNumberLookupRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsPhoneNumberLookupRetrieveQueryOptions(id,phoneNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsPastListUrl = (params?: HireCandidateInterviewsPastListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/interviews/past/?${stringifiedParams}` : `/api/hire/candidate/interviews/past/`
}

/**
 * Convenience endpoint to list candidate's past interviews.
 */
export const hireCandidateInterviewsPastList = async (params?: HireCandidateInterviewsPastListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewSerializerForCandidateRetrieveList> => {

  return customFetch<PaginatedInterviewSerializerForCandidateRetrieveList>(getHireCandidateInterviewsPastListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsPastListInfiniteQueryKey = (params?: HireCandidateInterviewsPastListParams,) => {
    return [
    'infinite', `/api/hire/candidate/interviews/past/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateInterviewsPastListQueryKey = (params?: HireCandidateInterviewsPastListParams,) => {
    return [
    `/api/hire/candidate/interviews/past/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateInterviewsPastListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, HireCandidateInterviewsPastListParams['page']>, TError = void>(params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsPastListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, QueryKey, HireCandidateInterviewsPastListParams['page']> = ({ signal, pageParam }) => hireCandidateInterviewsPastList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsPastListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>>
export type HireCandidateInterviewsPastListInfiniteQueryError = void


export function useHireCandidateInterviewsPastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, HireCandidateInterviewsPastListParams['page']>, TError = void>(
 params: undefined |  HireCandidateInterviewsPastListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, HireCandidateInterviewsPastListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, HireCandidateInterviewsPastListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsPastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, HireCandidateInterviewsPastListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData, QueryKey, HireCandidateInterviewsPastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsPastListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsPastListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError = void>(params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsPastListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>> = ({ signal }) => hireCandidateInterviewsPastList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsPastListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>>
export type HireCandidateInterviewsPastListQueryError = void


export function useHireCandidateInterviewsPastList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError = void>(
 params: undefined |  HireCandidateInterviewsPastListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPastList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPastList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsPastList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError = void>(
 params?: HireCandidateInterviewsPastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsPastListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsPendingListUrl = (params?: HireCandidateInterviewsPendingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/interviews/pending/?${stringifiedParams}` : `/api/hire/candidate/interviews/pending/`
}

/**
 * Convenience endpoint to list candidate's pending interviews.
 */
export const hireCandidateInterviewsPendingList = async (params?: HireCandidateInterviewsPendingListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewList> => {

  return customFetch<PaginatedInterviewList>(getHireCandidateInterviewsPendingListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsPendingListInfiniteQueryKey = (params?: HireCandidateInterviewsPendingListParams,) => {
    return [
    'infinite', `/api/hire/candidate/interviews/pending/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateInterviewsPendingListQueryKey = (params?: HireCandidateInterviewsPendingListParams,) => {
    return [
    `/api/hire/candidate/interviews/pending/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateInterviewsPendingListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, HireCandidateInterviewsPendingListParams['page']>, TError = void>(params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsPendingListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, QueryKey, HireCandidateInterviewsPendingListParams['page']> = ({ signal, pageParam }) => hireCandidateInterviewsPendingList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsPendingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>>
export type HireCandidateInterviewsPendingListInfiniteQueryError = void


export function useHireCandidateInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, HireCandidateInterviewsPendingListParams['page']>, TError = void>(
 params: undefined |  HireCandidateInterviewsPendingListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, HireCandidateInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, HireCandidateInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, HireCandidateInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsPendingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsPendingListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError = void>(params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsPendingListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>> = ({ signal }) => hireCandidateInterviewsPendingList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsPendingListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>>
export type HireCandidateInterviewsPendingListQueryError = void


export function useHireCandidateInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError = void>(
 params: undefined |  HireCandidateInterviewsPendingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError = void>(
 params?: HireCandidateInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsPendingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsUnratedListUrl = (params?: HireCandidateInterviewsUnratedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/interviews/unrated/?${stringifiedParams}` : `/api/hire/candidate/interviews/unrated/`
}

/**
 * Convenience endpoint to list candidate's unrated interviews.
 */
export const hireCandidateInterviewsUnratedList = async (params?: HireCandidateInterviewsUnratedListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewList> => {

  return customFetch<PaginatedInterviewList>(getHireCandidateInterviewsUnratedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsUnratedListInfiniteQueryKey = (params?: HireCandidateInterviewsUnratedListParams,) => {
    return [
    'infinite', `/api/hire/candidate/interviews/unrated/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateInterviewsUnratedListQueryKey = (params?: HireCandidateInterviewsUnratedListParams,) => {
    return [
    `/api/hire/candidate/interviews/unrated/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateInterviewsUnratedListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, HireCandidateInterviewsUnratedListParams['page']>, TError = void>(params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsUnratedListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, QueryKey, HireCandidateInterviewsUnratedListParams['page']> = ({ signal, pageParam }) => hireCandidateInterviewsUnratedList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsUnratedListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>>
export type HireCandidateInterviewsUnratedListInfiniteQueryError = void


export function useHireCandidateInterviewsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, HireCandidateInterviewsUnratedListParams['page']>, TError = void>(
 params: undefined |  HireCandidateInterviewsUnratedListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, HireCandidateInterviewsUnratedListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, HireCandidateInterviewsUnratedListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsUnratedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, HireCandidateInterviewsUnratedListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData, QueryKey, HireCandidateInterviewsUnratedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsUnratedListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsUnratedListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError = void>(params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsUnratedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>> = ({ signal }) => hireCandidateInterviewsUnratedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsUnratedListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>>
export type HireCandidateInterviewsUnratedListQueryError = void


export function useHireCandidateInterviewsUnratedList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError = void>(
 params: undefined |  HireCandidateInterviewsUnratedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUnratedList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUnratedList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsUnratedList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError = void>(
 params?: HireCandidateInterviewsUnratedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUnratedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsUnratedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsUpcomingListUrl = (params?: HireCandidateInterviewsUpcomingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/interviews/upcoming/?${stringifiedParams}` : `/api/hire/candidate/interviews/upcoming/`
}

/**
 * Convenience endpoint to list candidate's upcoming interviews.
 */
export const hireCandidateInterviewsUpcomingList = async (params?: HireCandidateInterviewsUpcomingListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewList> => {

  return customFetch<PaginatedInterviewList>(getHireCandidateInterviewsUpcomingListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateInterviewsUpcomingListInfiniteQueryKey = (params?: HireCandidateInterviewsUpcomingListParams,) => {
    return [
    'infinite', `/api/hire/candidate/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateInterviewsUpcomingListQueryKey = (params?: HireCandidateInterviewsUpcomingListParams,) => {
    return [
    `/api/hire/candidate/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateInterviewsUpcomingListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, HireCandidateInterviewsUpcomingListParams['page']>, TError = void>(params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsUpcomingListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, QueryKey, HireCandidateInterviewsUpcomingListParams['page']> = ({ signal, pageParam }) => hireCandidateInterviewsUpcomingList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsUpcomingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>>
export type HireCandidateInterviewsUpcomingListInfiniteQueryError = void


export function useHireCandidateInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, HireCandidateInterviewsUpcomingListParams['page']>, TError = void>(
 params: undefined |  HireCandidateInterviewsUpcomingListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, HireCandidateInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, HireCandidateInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, HireCandidateInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData, QueryKey, HireCandidateInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsUpcomingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateInterviewsUpcomingListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError = void>(params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateInterviewsUpcomingListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>> = ({ signal }) => hireCandidateInterviewsUpcomingList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateInterviewsUpcomingListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>>
export type HireCandidateInterviewsUpcomingListQueryError = void


export function useHireCandidateInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError = void>(
 params: undefined |  HireCandidateInterviewsUpcomingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError = void>(
 params?: HireCandidateInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateInterviewsUpcomingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateScreeningInterviewsListUrl = (params?: HireCandidateScreeningInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/screening-interviews/?${stringifiedParams}` : `/api/hire/candidate/screening-interviews/`
}

/**
 * Pro-side: list/retrieve invites, confirm, or ask to reschedule.
 */
export const hireCandidateScreeningInterviewsList = async (params?: HireCandidateScreeningInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedScreeningInterviewList> => {

  return customFetch<PaginatedScreeningInterviewList>(getHireCandidateScreeningInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateScreeningInterviewsListInfiniteQueryKey = (params?: HireCandidateScreeningInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/candidate/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateScreeningInterviewsListQueryKey = (params?: HireCandidateScreeningInterviewsListParams,) => {
    return [
    `/api/hire/candidate/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateScreeningInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, HireCandidateScreeningInterviewsListParams['page']>, TError = void>(params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateScreeningInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, QueryKey, HireCandidateScreeningInterviewsListParams['page']> = ({ signal, pageParam }) => hireCandidateScreeningInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateScreeningInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>>
export type HireCandidateScreeningInterviewsListInfiniteQueryError = void


export function useHireCandidateScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, HireCandidateScreeningInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireCandidateScreeningInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, HireCandidateScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, HireCandidateScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, HireCandidateScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateScreeningInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateScreeningInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError = void>(params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateScreeningInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>> = ({ signal }) => hireCandidateScreeningInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateScreeningInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>>
export type HireCandidateScreeningInterviewsListQueryError = void


export function useHireCandidateScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError = void>(
 params: undefined |  HireCandidateScreeningInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateScreeningInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateScreeningInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/candidate/screening-interviews/${id}/`
}

/**
 * Pro-side: list/retrieve invites, confirm, or ask to reschedule.
 */
export const hireCandidateScreeningInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewRetrieve> => {

  return customFetch<ScreeningInterviewRetrieve>(getHireCandidateScreeningInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateScreeningInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/candidate/screening-interviews/${id}/`
    ] as const;
    }


export const getHireCandidateScreeningInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateScreeningInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>> = ({ signal }) => hireCandidateScreeningInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateScreeningInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>>
export type HireCandidateScreeningInterviewsRetrieveQueryError = void


export function useHireCandidateScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateScreeningInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateScreeningInterviewsConfirmationsCreateUrl = (id: string,) => {




  return `/api/hire/candidate/screening-interviews/${id}/confirmations/`
}

/**
 * Pro-side: list/retrieve invites, confirm, or ask to reschedule.
 */
export const hireCandidateScreeningInterviewsConfirmationsCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterview> => {

  return customFetch<ScreeningInterview>(getHireCandidateScreeningInterviewsConfirmationsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireCandidateScreeningInterviewsConfirmationsCreateMutationKey = () => ['hireCandidateScreeningInterviewsConfirmationsCreate'] as const;

export const getHireCandidateScreeningInterviewsConfirmationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>, TError,HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>, TError,HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables, TContext> => {

const mutationKey = getHireCandidateScreeningInterviewsConfirmationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>, HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireCandidateScreeningInterviewsConfirmationsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireCandidateScreeningInterviewsConfirmationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>>

    export type HireCandidateScreeningInterviewsConfirmationsCreateMutationError = void
    export type HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables = {id: string}

    export const useHireCandidateScreeningInterviewsConfirmationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>, TError,HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireCandidateScreeningInterviewsConfirmationsCreate>>,
        TError,
        HireCandidateScreeningInterviewsConfirmationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireCandidateScreeningInterviewsConfirmationsCreateMutationOptions(options), queryClient);
    }
    export const getHireCandidateScreeningInterviewsRescheduleRequestsCreateUrl = (id: string,) => {




  return `/api/hire/candidate/screening-interviews/${id}/reschedule-requests/`
}

/**
 * Pro-side: list/retrieve invites, confirm, or ask to reschedule.
 */
export const hireCandidateScreeningInterviewsRescheduleRequestsCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterview> => {

  return customFetch<ScreeningInterview>(getHireCandidateScreeningInterviewsRescheduleRequestsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireCandidateScreeningInterviewsRescheduleRequestsCreateMutationKey = () => ['hireCandidateScreeningInterviewsRescheduleRequestsCreate'] as const;

export const getHireCandidateScreeningInterviewsRescheduleRequestsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>, TError,HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>, TError,HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables, TContext> => {

const mutationKey = getHireCandidateScreeningInterviewsRescheduleRequestsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>, HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireCandidateScreeningInterviewsRescheduleRequestsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>>

    export type HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationError = void
    export type HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables = {id: string}

    export const useHireCandidateScreeningInterviewsRescheduleRequestsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>, TError,HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireCandidateScreeningInterviewsRescheduleRequestsCreate>>,
        TError,
        HireCandidateScreeningInterviewsRescheduleRequestsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireCandidateScreeningInterviewsRescheduleRequestsCreateMutationOptions(options), queryClient);
    }
    export const getHireCandidateScreeningInterviewsPendingListUrl = (params?: HireCandidateScreeningInterviewsPendingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidate/screening-interviews/pending/?${stringifiedParams}` : `/api/hire/candidate/screening-interviews/pending/`
}

/**
 * Pro-side: list/retrieve invites, confirm, or ask to reschedule.
 */
export const hireCandidateScreeningInterviewsPendingList = async (params?: HireCandidateScreeningInterviewsPendingListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedScreeningInterviewList> => {

  return customFetch<PaginatedScreeningInterviewList>(getHireCandidateScreeningInterviewsPendingListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidateScreeningInterviewsPendingListInfiniteQueryKey = (params?: HireCandidateScreeningInterviewsPendingListParams,) => {
    return [
    'infinite', `/api/hire/candidate/screening-interviews/pending/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidateScreeningInterviewsPendingListQueryKey = (params?: HireCandidateScreeningInterviewsPendingListParams,) => {
    return [
    `/api/hire/candidate/screening-interviews/pending/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidateScreeningInterviewsPendingListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, HireCandidateScreeningInterviewsPendingListParams['page']>, TError = void>(params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateScreeningInterviewsPendingListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']> = ({ signal, pageParam }) => hireCandidateScreeningInterviewsPendingList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateScreeningInterviewsPendingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>>
export type HireCandidateScreeningInterviewsPendingListInfiniteQueryError = void


export function useHireCandidateScreeningInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, HireCandidateScreeningInterviewsPendingListParams['page']>, TError = void>(
 params: undefined |  HireCandidateScreeningInterviewsPendingListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, HireCandidateScreeningInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, HireCandidateScreeningInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateScreeningInterviewsPendingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, HireCandidateScreeningInterviewsPendingListParams['page']>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData, QueryKey, HireCandidateScreeningInterviewsPendingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateScreeningInterviewsPendingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidateScreeningInterviewsPendingListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError = void>(params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidateScreeningInterviewsPendingListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>> = ({ signal }) => hireCandidateScreeningInterviewsPendingList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidateScreeningInterviewsPendingListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>>
export type HireCandidateScreeningInterviewsPendingListQueryError = void


export function useHireCandidateScreeningInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError = void>(
 params: undefined |  HireCandidateScreeningInterviewsPendingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidateScreeningInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidateScreeningInterviewsPendingList<TData = Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError = void>(
 params?: HireCandidateScreeningInterviewsPendingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidateScreeningInterviewsPendingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidateScreeningInterviewsPendingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidatesListUrl = (params?: HireCandidatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/candidates/?${stringifiedParams}` : `/api/hire/candidates/`
}

/**
 * The Hire Candidates page browse (list-only — see module docstring).
 */
export const hireCandidatesList = async (params?: HireCandidatesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCandidateList> => {

  return customFetch<PaginatedCandidateList>(getHireCandidatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireCandidatesListInfiniteQueryKey = (params?: HireCandidatesListParams,) => {
    return [
    'infinite', `/api/hire/candidates/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireCandidatesListQueryKey = (params?: HireCandidatesListParams,) => {
    return [
    `/api/hire/candidates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireCandidatesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireCandidatesList>>, HireCandidatesListParams['page']>, TError = void>(params?: HireCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidatesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidatesList>>, QueryKey, HireCandidatesListParams['page']> = ({ signal, pageParam }) => hireCandidatesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidatesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidatesList>>>
export type HireCandidatesListInfiniteQueryError = void


export function useHireCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidatesList>>, HireCandidatesListParams['page']>, TError = void>(
 params: undefined |  HireCandidatesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidatesList>>, HireCandidatesListParams['page']>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidatesList>>, HireCandidatesListParams['page']>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireCandidatesList>>, HireCandidatesListParams['page']>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData, QueryKey, HireCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidatesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireCandidatesListQueryOptions = <TData = Awaited<ReturnType<typeof hireCandidatesList>>, TError = void>(params?: HireCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireCandidatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireCandidatesList>>> = ({ signal }) => hireCandidatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireCandidatesListQueryResult = NonNullable<Awaited<ReturnType<typeof hireCandidatesList>>>
export type HireCandidatesListQueryError = void


export function useHireCandidatesList<TData = Awaited<ReturnType<typeof hireCandidatesList>>, TError = void>(
 params: undefined |  HireCandidatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidatesList<TData = Awaited<ReturnType<typeof hireCandidatesList>>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof hireCandidatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireCandidatesList<TData = Awaited<ReturnType<typeof hireCandidatesList>>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireCandidatesList<TData = Awaited<ReturnType<typeof hireCandidatesList>>, TError = void>(
 params?: HireCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireCandidatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsListUrl = (params?: HireInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/interviews/?${stringifiedParams}` : `/api/hire/interviews/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsList = async (params?: HireInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsListInfiniteQueryKey = (params?: HireInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireInterviewsListQueryKey = (params?: HireInterviewsListParams,) => {
    return [
    `/api/hire/interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsList>>, HireInterviewsListParams['page']>, TError = void>(params?: HireInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsList>>, QueryKey, HireInterviewsListParams['page']> = ({ signal, pageParam }) => hireInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsList>>>
export type HireInterviewsListInfiniteQueryError = void


export function useHireInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsList>>, HireInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsList>>, HireInterviewsListParams['page']>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsList>>, HireInterviewsListParams['page']>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsList>>, HireInterviewsListParams['page']>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData, QueryKey, HireInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsList>>, TError = void>(params?: HireInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsList>>> = ({ signal }) => hireInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsList>>>
export type HireInterviewsListQueryError = void


export function useHireInterviewsList<TData = Awaited<ReturnType<typeof hireInterviewsList>>, TError = void>(
 params: undefined |  HireInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsList<TData = Awaited<ReturnType<typeof hireInterviewsList>>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsList<TData = Awaited<ReturnType<typeof hireInterviewsList>>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsList<TData = Awaited<ReturnType<typeof hireInterviewsList>>, TError = void>(
 params?: HireInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsCreateUrl = () => {




  return `/api/hire/interviews/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsCreate = async (interviewDTORequest: InterviewDTORequest, options?: Parameters<typeof customFetch>[1]): Promise<InterviewDTO> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewDTO>(getHireInterviewsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interviewDTORequest)
  }
);}





export const getHireInterviewsCreateMutationKey = () => ['hireInterviewsCreate'] as const;

export const getHireInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsCreate>>, TError,HireInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsCreate>>, TError,HireInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsCreate>>, HireInterviewsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireInterviewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsCreate>>>
    export type HireInterviewsCreateMutationBody = InterviewDTORequest
    export type HireInterviewsCreateMutationError = void
    export type HireInterviewsCreateMutationVariables = {data: InterviewDTORequest}

    export const useHireInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsCreate>>, TError,HireInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsCreate>>,
        TError,
        HireInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireInterviewsHiringScheduleListUrl = (params: HireInterviewsHiringScheduleListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/interviews/hiring-schedule/?${stringifiedParams}` : `/api/hire/interviews/hiring-schedule/`
}

/**
 * Interview "shifts" for a location's OPEN job postings within a week window.
 *
 * Powers the business Hiring Schedule week grid (CORE-6259/6488). Returns offered (``INVITED``),
 * confirmed, and terminal (``DECLINED`` / ``CANCELLED``) items; the FE renders/filters the grid
 * client-side off each card's ``kind`` / ``status`` / ``fill_state``. Filters on each item's own
 * ``start_time`` (not the gig-stage time) so offered interviews with no gig yet are included.
 * Unpaginated array shaped for the marketplace calendar's event contract; every item carries
 * ``kind``.
 *
 * Two kinds share the feed: working (trial-shift) ``Interview``s and phone/video/in-person
 * ``ScreeningInterview``s (CORE-6488), merged and sorted by ``start_time``.
 */
export const hireInterviewsHiringScheduleList = async (params: HireInterviewsHiringScheduleListParams, options?: Parameters<typeof customFetch>[1]): Promise<HiringScheduleItem[]> => {

  return customFetch<HiringScheduleItem[]>(getHireInterviewsHiringScheduleListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsHiringScheduleListQueryKey = (params?: HireInterviewsHiringScheduleListParams,) => {
    return [
    `/api/hire/interviews/hiring-schedule/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireInterviewsHiringScheduleListQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError = void>(params: HireInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsHiringScheduleListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>> = ({ signal }) => hireInterviewsHiringScheduleList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsHiringScheduleListQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>>
export type HireInterviewsHiringScheduleListQueryError = void


export function useHireInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError = void>(
 params: HireInterviewsHiringScheduleListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError = void>(
 params: HireInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError = void>(
 params: HireInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError = void>(
 params: HireInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsHiringScheduleListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsHistoryListUrl = (params?: HireInterviewsHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/interviews/history/?${stringifiedParams}` : `/api/hire/interviews/history/`
}

/**
 * Convenience endpoint to list staffer's historic interviews.
 */
export const hireInterviewsHistoryList = async (params?: HireInterviewsHistoryListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireInterviewsHistoryListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsHistoryListInfiniteQueryKey = (params?: HireInterviewsHistoryListParams,) => {
    return [
    'infinite', `/api/hire/interviews/history/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireInterviewsHistoryListQueryKey = (params?: HireInterviewsHistoryListParams,) => {
    return [
    `/api/hire/interviews/history/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireInterviewsHistoryListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, HireInterviewsHistoryListParams['page']>, TError = void>(params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsHistoryListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, QueryKey, HireInterviewsHistoryListParams['page']> = ({ signal, pageParam }) => hireInterviewsHistoryList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsHistoryListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsHistoryList>>>
export type HireInterviewsHistoryListInfiniteQueryError = void


export function useHireInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, HireInterviewsHistoryListParams['page']>, TError = void>(
 params: undefined |  HireInterviewsHistoryListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, HireInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, HireInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, HireInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData, QueryKey, HireInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsHistoryListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError = void>(params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsHistoryListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsHistoryList>>> = ({ signal }) => hireInterviewsHistoryList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsHistoryList>>>
export type HireInterviewsHistoryListQueryError = void


export function useHireInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError = void>(
 params: undefined |  HireInterviewsHistoryListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError = void>(
 params?: HireInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsHistoryListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsPayDueListUrl = (params?: HireInterviewsPayDueListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/interviews/pay-due/?${stringifiedParams}` : `/api/hire/interviews/pay-due/`
}

/**
 * Convenience endpoint to list staffer's pay due interviews.
 */
export const hireInterviewsPayDueList = async (params?: HireInterviewsPayDueListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireInterviewsPayDueListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsPayDueListInfiniteQueryKey = (params?: HireInterviewsPayDueListParams,) => {
    return [
    'infinite', `/api/hire/interviews/pay-due/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireInterviewsPayDueListQueryKey = (params?: HireInterviewsPayDueListParams,) => {
    return [
    `/api/hire/interviews/pay-due/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireInterviewsPayDueListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, HireInterviewsPayDueListParams['page']>, TError = void>(params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsPayDueListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, QueryKey, HireInterviewsPayDueListParams['page']> = ({ signal, pageParam }) => hireInterviewsPayDueList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsPayDueListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsPayDueList>>>
export type HireInterviewsPayDueListInfiniteQueryError = void


export function useHireInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, HireInterviewsPayDueListParams['page']>, TError = void>(
 params: undefined |  HireInterviewsPayDueListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, HireInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, HireInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, HireInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData, QueryKey, HireInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsPayDueListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsPayDueListQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError = void>(params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsPayDueListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsPayDueList>>> = ({ signal }) => hireInterviewsPayDueList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsPayDueListQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsPayDueList>>>
export type HireInterviewsPayDueListQueryError = void


export function useHireInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError = void>(
 params: undefined |  HireInterviewsPayDueListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsPayDueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError = void>(
 params?: HireInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsPayDueListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsUpcomingListUrl = (params?: HireInterviewsUpcomingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/interviews/upcoming/?${stringifiedParams}` : `/api/hire/interviews/upcoming/`
}

/**
 * Convenience endpoint to list staffer's upcoming interviews.
 */
export const hireInterviewsUpcomingList = async (params?: HireInterviewsUpcomingListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireInterviewsUpcomingListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsUpcomingListInfiniteQueryKey = (params?: HireInterviewsUpcomingListParams,) => {
    return [
    'infinite', `/api/hire/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireInterviewsUpcomingListQueryKey = (params?: HireInterviewsUpcomingListParams,) => {
    return [
    `/api/hire/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireInterviewsUpcomingListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, HireInterviewsUpcomingListParams['page']>, TError = void>(params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsUpcomingListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, QueryKey, HireInterviewsUpcomingListParams['page']> = ({ signal, pageParam }) => hireInterviewsUpcomingList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsUpcomingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>>
export type HireInterviewsUpcomingListInfiniteQueryError = void


export function useHireInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, HireInterviewsUpcomingListParams['page']>, TError = void>(
 params: undefined |  HireInterviewsUpcomingListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, HireInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, HireInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, HireInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData, QueryKey, HireInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsUpcomingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsUpcomingListQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError = void>(params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsUpcomingListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>> = ({ signal }) => hireInterviewsUpcomingList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsUpcomingListQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>>
export type HireInterviewsUpcomingListQueryError = void


export function useHireInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError = void>(
 params: undefined |  HireInterviewsUpcomingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError = void>(
 params?: HireInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsUpcomingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsReviewsCreateUrl = (interviewId: string,) => {




  return `/api/hire/interviews/${interviewId}/reviews/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsReviewsCreate = async (interviewId: string,
    stafferReviewRequest: StafferReviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferReview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferReview>(getHireInterviewsReviewsCreateUrl(interviewId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferReviewRequest)
  }
);}





export const getHireInterviewsReviewsCreateMutationKey = () => ['hireInterviewsReviewsCreate'] as const;

export const getHireInterviewsReviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>, TError,HireInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>, TError,HireInterviewsReviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsReviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>, HireInterviewsReviewsCreateMutationVariables> = (props) => {
          const {interviewId,data} = props ?? {};

          return  hireInterviewsReviewsCreate(interviewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>>
    export type HireInterviewsReviewsCreateMutationBody = StafferReviewRequest
    export type HireInterviewsReviewsCreateMutationError = void
    export type HireInterviewsReviewsCreateMutationVariables = {interviewId: string;data: StafferReviewRequest}

    export const useHireInterviewsReviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>, TError,HireInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsReviewsCreate>>,
        TError,
        HireInterviewsReviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsReviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/interviews/${id}/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/interviews/${id}/`
    ] as const;
    }


export const getHireInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireInterviewsRetrieve>>> = ({ signal }) => hireInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsRetrieve>>>
export type HireInterviewsRetrieveQueryError = void


export function useHireInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireInterviewsFeedbackUpdateUrl = (id: string,) => {




  return `/api/hire/interviews/${id}/feedback/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsFeedbackUpdate = async (id: string,
    interviewFeedbackRequest: InterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtendedInterviewManager>(getHireInterviewsFeedbackUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interviewFeedbackRequest)
  }
);}





export const getHireInterviewsFeedbackUpdateMutationKey = () => ['hireInterviewsFeedbackUpdate'] as const;

export const getHireInterviewsFeedbackUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>, TError,HireInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>, TError,HireInterviewsFeedbackUpdateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsFeedbackUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>, HireInterviewsFeedbackUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireInterviewsFeedbackUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsFeedbackUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>>
    export type HireInterviewsFeedbackUpdateMutationBody = InterviewFeedbackRequest
    export type HireInterviewsFeedbackUpdateMutationError = void
    export type HireInterviewsFeedbackUpdateMutationVariables = {id: string;data: InterviewFeedbackRequest}

    export const useHireInterviewsFeedbackUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>, TError,HireInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsFeedbackUpdate>>,
        TError,
        HireInterviewsFeedbackUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsFeedbackUpdateMutationOptions(options), queryClient);
    }
    export const getHireInterviewsFeedbackPartialUpdateUrl = (id: string,) => {




  return `/api/hire/interviews/${id}/feedback/`
}

/**
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 */
export const hireInterviewsFeedbackPartialUpdate = async (id: string,
    patchedInterviewFeedbackRequest?: PatchedInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtendedInterviewManager>(getHireInterviewsFeedbackPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedInterviewFeedbackRequest)
  }
);}





export const getHireInterviewsFeedbackPartialUpdateMutationKey = () => ['hireInterviewsFeedbackPartialUpdate'] as const;

export const getHireInterviewsFeedbackPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>, TError,HireInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>, TError,HireInterviewsFeedbackPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsFeedbackPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>, HireInterviewsFeedbackPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireInterviewsFeedbackPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsFeedbackPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>>
    export type HireInterviewsFeedbackPartialUpdateMutationBody = PatchedInterviewFeedbackRequest | undefined
    export type HireInterviewsFeedbackPartialUpdateMutationError = void
    export type HireInterviewsFeedbackPartialUpdateMutationVariables = {id: string;data?: PatchedInterviewFeedbackRequest}

    export const useHireInterviewsFeedbackPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>, TError,HireInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsFeedbackPartialUpdate>>,
        TError,
        HireInterviewsFeedbackPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsFeedbackPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireInterviewsPassCreateUrl = (id: string,) => {




  return `/api/hire/interviews/${id}/pass/`
}

/**
 * Pass on the Pro after a tryout that happened: records the manager's PASS review, so the tryout no longer counts as having gone well, and logs it to the job's activity. 400 when the interview is not reviewable or was already reviewed. 404 when the working-interview feature is off for the location.
 */
export const hireInterviewsPassCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireInterviewsPassCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireInterviewsPassCreateMutationKey = () => ['hireInterviewsPassCreate'] as const;

export const getHireInterviewsPassCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsPassCreate>>, TError,HireInterviewsPassCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsPassCreate>>, TError,HireInterviewsPassCreateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsPassCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsPassCreate>>, HireInterviewsPassCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireInterviewsPassCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsPassCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsPassCreate>>>

    export type HireInterviewsPassCreateMutationError = void
    export type HireInterviewsPassCreateMutationVariables = {id: string}

    export const useHireInterviewsPassCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsPassCreate>>, TError,HireInterviewsPassCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsPassCreate>>,
        TError,
        HireInterviewsPassCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsPassCreateMutationOptions(options), queryClient);
    }
    export const getHireInterviewsRemoveCreateUrl = (id: string,) => {




  return `/api/hire/interviews/${id}/remove/`
}

/**
 * Remove a booked Pro before the shift starts: cancels their tryout, reopens the seat and logs it to the job's activity. 400 when the Pro is not booked or the shift has started. 404 when the working-interview feature is off for the location.
 */
export const hireInterviewsRemoveCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireInterviewsRemoveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireInterviewsRemoveCreateMutationKey = () => ['hireInterviewsRemoveCreate'] as const;

export const getHireInterviewsRemoveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>, TError,HireInterviewsRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>, TError,HireInterviewsRemoveCreateMutationVariables, TContext> => {

const mutationKey = getHireInterviewsRemoveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>, HireInterviewsRemoveCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireInterviewsRemoveCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireInterviewsRemoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>>

    export type HireInterviewsRemoveCreateMutationError = void
    export type HireInterviewsRemoveCreateMutationVariables = {id: string}

    export const useHireInterviewsRemoveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>, TError,HireInterviewsRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireInterviewsRemoveCreate>>,
        TError,
        HireInterviewsRemoveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireInterviewsRemoveCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsListUrl = (params?: HireJobsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/?${stringifiedParams}` : `/api/hire/jobs/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsList = async (params?: HireJobsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobPostingResponseList> => {

  return customFetch<PaginatedJobPostingResponseList>(getHireJobsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsListInfiniteQueryKey = (params?: HireJobsListParams,) => {
    return [
    'infinite', `/api/hire/jobs/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireJobsListQueryKey = (params?: HireJobsListParams,) => {
    return [
    `/api/hire/jobs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireJobsList>>, HireJobsListParams['page']>, TError = void>(params?: HireJobsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsList>>, QueryKey, HireJobsListParams['page']> = ({ signal, pageParam }) => hireJobsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsList>>>
export type HireJobsListInfiniteQueryError = void


export function useHireJobsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsList>>, HireJobsListParams['page']>, TError = void>(
 params: undefined |  HireJobsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsList>>, HireJobsListParams['page']>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsList>>, HireJobsListParams['page']>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsList>>, HireJobsListParams['page']>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData, QueryKey, HireJobsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsList>>, TError = void>(params?: HireJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsList>>> = ({ signal }) => hireJobsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsList>>>
export type HireJobsListQueryError = void


export function useHireJobsList<TData = Awaited<ReturnType<typeof hireJobsList>>, TError = void>(
 params: undefined |  HireJobsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsList<TData = Awaited<ReturnType<typeof hireJobsList>>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsList<TData = Awaited<ReturnType<typeof hireJobsList>>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsList<TData = Awaited<ReturnType<typeof hireJobsList>>, TError = void>(
 params?: HireJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsCreateUrl = () => {




  return `/api/hire/jobs/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsCreate = async (jobPostingRequest: JobPostingRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobPostingResponse>(getHireJobsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobPostingRequest)
  }
);}





export const getHireJobsCreateMutationKey = () => ['hireJobsCreate'] as const;

export const getHireJobsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsCreate>>, TError,HireJobsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsCreate>>, TError,HireJobsCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsCreate>>, HireJobsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireJobsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsCreate>>>
    export type HireJobsCreateMutationBody = JobPostingRequest
    export type HireJobsCreateMutationError = void
    export type HireJobsCreateMutationVariables = {data: JobPostingRequest}

    export const useHireJobsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsCreate>>, TError,HireJobsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsCreate>>,
        TError,
        HireJobsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsRetrieveUrl = (id: string,) => {




  return `/api/hire/jobs/${id}/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingResponseWithApplicationDate> => {

  return customFetch<JobPostingResponseWithApplicationDate>(getHireJobsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/jobs/${id}/`
    ] as const;
    }


export const getHireJobsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsRetrieve>>> = ({ signal }) => hireJobsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsRetrieve>>>
export type HireJobsRetrieveQueryError = void


export function useHireJobsRetrieve<TData = Awaited<ReturnType<typeof hireJobsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsRetrieve<TData = Awaited<ReturnType<typeof hireJobsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsRetrieve<TData = Awaited<ReturnType<typeof hireJobsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsRetrieve<TData = Awaited<ReturnType<typeof hireJobsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsUpdateUrl = (id: string,) => {




  return `/api/hire/jobs/${id}/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsUpdate = async (id: string,
    jobPostingRequest: JobPostingRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobPostingResponse>(getHireJobsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobPostingRequest)
  }
);}





export const getHireJobsUpdateMutationKey = () => ['hireJobsUpdate'] as const;

export const getHireJobsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsUpdate>>, TError,HireJobsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsUpdate>>, TError,HireJobsUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsUpdate>>, HireJobsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireJobsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsUpdate>>>
    export type HireJobsUpdateMutationBody = JobPostingRequest
    export type HireJobsUpdateMutationError = void
    export type HireJobsUpdateMutationVariables = {id: string;data: JobPostingRequest}

    export const useHireJobsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsUpdate>>, TError,HireJobsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsUpdate>>,
        TError,
        HireJobsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobsPartialUpdateUrl = (id: string,) => {




  return `/api/hire/jobs/${id}/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsPartialUpdate = async (id: string,
    patchedJobPostingRequest?: PatchedJobPostingRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobPostingResponse>(getHireJobsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobPostingRequest)
  }
);}





export const getHireJobsPartialUpdateMutationKey = () => ['hireJobsPartialUpdate'] as const;

export const getHireJobsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsPartialUpdate>>, TError,HireJobsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsPartialUpdate>>, TError,HireJobsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsPartialUpdate>>, HireJobsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireJobsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsPartialUpdate>>>
    export type HireJobsPartialUpdateMutationBody = PatchedJobPostingRequest | undefined
    export type HireJobsPartialUpdateMutationError = void
    export type HireJobsPartialUpdateMutationVariables = {id: string;data?: PatchedJobPostingRequest}

    export const useHireJobsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsPartialUpdate>>, TError,HireJobsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsPartialUpdate>>,
        TError,
        HireJobsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobsDestroyUrl = (id: string,
    params?: HireJobsDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${id}/?${stringifiedParams}` : `/api/hire/jobs/${id}/`
}

/**
 * Job postings for permanent and long-term hire positions.
 *
 * Managers create postings with skill requirements, wage range, and
 * experience level. Postings have expiration dates and status tracking.
 */
export const hireJobsDestroy = async (id: string,
    params?: HireJobsDestroyParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getHireJobsDestroyUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHireJobsDestroyMutationKey = () => ['hireJobsDestroy'] as const;

export const getHireJobsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsDestroy>>, TError,HireJobsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsDestroy>>, TError,HireJobsDestroyMutationVariables, TContext> => {

const mutationKey = getHireJobsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsDestroy>>, HireJobsDestroyMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  hireJobsDestroy(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsDestroy>>>

    export type HireJobsDestroyMutationError = void
    export type HireJobsDestroyMutationVariables = {id: string;params?: HireJobsDestroyParams}

    export const useHireJobsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsDestroy>>, TError,HireJobsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsDestroy>>,
        TError,
        HireJobsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsDestroyMutationOptions(options), queryClient);
    }
    export const getHireJobsPublishCreateUrl = (id: string,) => {




  return `/api/hire/jobs/${id}/publish/`
}

/**
 * Make a direct-hire job public (WORK-9920). Only a private job, or an archived one that never hired anyone, can be published. If an open job at the location already has the title, the response is a 400 with a `name` error; retry with a new `name`.
 */
export const hireJobsPublishCreate = async (id: string,
    publishJobPostingRequest?: PublishJobPostingRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingResponseWithApplicationDate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobPostingResponseWithApplicationDate>(getHireJobsPublishCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(publishJobPostingRequest)
  }
);}





export const getHireJobsPublishCreateMutationKey = () => ['hireJobsPublishCreate'] as const;

export const getHireJobsPublishCreateMutationOptions = <TError = HireJobsPublishCreate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsPublishCreate>>, TError,HireJobsPublishCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsPublishCreate>>, TError,HireJobsPublishCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsPublishCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsPublishCreate>>, HireJobsPublishCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireJobsPublishCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsPublishCreate>>>
    export type HireJobsPublishCreateMutationBody = PublishJobPostingRequest | undefined
    export type HireJobsPublishCreateMutationError = HireJobsPublishCreate400 | void
    export type HireJobsPublishCreateMutationVariables = {id: string;data?: PublishJobPostingRequest}

    export const useHireJobsPublishCreate = <TError = HireJobsPublishCreate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsPublishCreate>>, TError,HireJobsPublishCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsPublishCreate>>,
        TError,
        HireJobsPublishCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsPublishCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsBulkCreateUrl = () => {




  return `/api/hire/jobs/bulk/`
}

/**
 * Create up to 100 job postings in one request, with partial-success semantics.
 *
 * Per-item shape validation happens here (the view has the Request needed by
 * CurrentUserDefault on the serializer's created_by HiddenField). The service
 * then handles dedup, per-item authorization, DB-conflict detection, and
 * persistence — see JobPostingService.bulk_create for the full skip taxonomy.
 */
export const hireJobsBulkCreate = async (bulkJobPostingCreateInputRequest: BulkJobPostingCreateInputRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkJobPostingCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkJobPostingCreateResponse>(getHireJobsBulkCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkJobPostingCreateInputRequest)
  }
);}





export const getHireJobsBulkCreateMutationKey = () => ['hireJobsBulkCreate'] as const;

export const getHireJobsBulkCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsBulkCreate>>, TError,HireJobsBulkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsBulkCreate>>, TError,HireJobsBulkCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsBulkCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsBulkCreate>>, HireJobsBulkCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireJobsBulkCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsBulkCreate>>>
    export type HireJobsBulkCreateMutationBody = BulkJobPostingCreateInputRequest
    export type HireJobsBulkCreateMutationError = void
    export type HireJobsBulkCreateMutationVariables = {data: BulkJobPostingCreateInputRequest}

    export const useHireJobsBulkCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsBulkCreate>>, TError,HireJobsBulkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsBulkCreate>>,
        TError,
        HireJobsBulkCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsBulkCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsExperienceLevelsListUrl = () => {




  return `/api/hire/jobs/experience-levels/`
}

/**
 * List available experience level options for job postings.
 */
export const hireJobsExperienceLevelsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ExperienceLevel[]> => {

  return customFetch<ExperienceLevel[]>(getHireJobsExperienceLevelsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsExperienceLevelsListQueryKey = () => {
    return [
    `/api/hire/jobs/experience-levels/`
    ] as const;
    }


export const getHireJobsExperienceLevelsListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsExperienceLevelsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>> = ({ signal }) => hireJobsExperienceLevelsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsExperienceLevelsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>>
export type HireJobsExperienceLevelsListQueryError = void


export function useHireJobsExperienceLevelsList<TData = Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsExperienceLevelsList<TData = Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsExperienceLevelsList<TData = Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsExperienceLevelsList<TData = Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsExperienceLevelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsExperienceLevelsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsLookupByLinkRetrieveUrl = (params: HireJobsLookupByLinkRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/lookup-by-link/?${stringifiedParams}` : `/api/hire/jobs/lookup-by-link/`
}

/**
 * Crawler-only lookup: resolve a JobPosting by exact `external_application_link`. Designed for the qwick_posting_id backfill that attaches JobRecord rows to their postings — bypasses the manager-scoped queryset on `GET /api/job-postings/` (which returns empty for service accounts that don't manage any location) and does the actual URL filter that the list endpoint silently ignores today.
 */
export const hireJobsLookupByLinkRetrieve = async (params: HireJobsLookupByLinkRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<JobPosting> => {

  return customFetch<JobPosting>(getHireJobsLookupByLinkRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsLookupByLinkRetrieveQueryKey = (params?: HireJobsLookupByLinkRetrieveParams,) => {
    return [
    `/api/hire/jobs/lookup-by-link/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsLookupByLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError = void>(params: HireJobsLookupByLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsLookupByLinkRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>> = ({ signal }) => hireJobsLookupByLinkRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsLookupByLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>>
export type HireJobsLookupByLinkRetrieveQueryError = void


export function useHireJobsLookupByLinkRetrieve<TData = Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError = void>(
 params: HireJobsLookupByLinkRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsLookupByLinkRetrieve<TData = Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError = void>(
 params: HireJobsLookupByLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsLookupByLinkRetrieve<TData = Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError = void>(
 params: HireJobsLookupByLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsLookupByLinkRetrieve<TData = Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError = void>(
 params: HireJobsLookupByLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsLookupByLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsLookupByLinkRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsProMatchStatusListUrl = (params?: HireJobsProMatchStatusListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/pro-match-status/?${stringifiedParams}` : `/api/hire/jobs/pro-match-status/`
}

/**
 * Returns open job postings with invite status and eligibility for a pro, or (with group_id)
 * every member of a ProGroup.
 */
export const hireJobsProMatchStatusList = async (params?: HireJobsProMatchStatusListParams, options?: Parameters<typeof customFetch>[1]): Promise<ProMatchStatusResult[]> => {

  return customFetch<ProMatchStatusResult[]>(getHireJobsProMatchStatusListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsProMatchStatusListQueryKey = (params?: HireJobsProMatchStatusListParams,) => {
    return [
    `/api/hire/jobs/pro-match-status/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsProMatchStatusListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: HireJobsProMatchStatusListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsProMatchStatusListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>> = ({ signal }) => hireJobsProMatchStatusList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsProMatchStatusListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>>
export type HireJobsProMatchStatusListQueryError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useHireJobsProMatchStatusList<TData = Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  HireJobsProMatchStatusListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsProMatchStatusList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsProMatchStatusList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsProMatchStatusList<TData = Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: HireJobsProMatchStatusListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsProMatchStatusList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsProMatchStatusList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsProMatchStatusList<TData = Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: HireJobsProMatchStatusListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsProMatchStatusList<TData = Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: HireJobsProMatchStatusListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsProMatchStatusList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsProMatchStatusListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsScrapeByUrlCreateUrl = () => {




  return `/api/hire/jobs/scrape-by-url/`
}

/**
 * Scrape a single posting URL via the job-crawler service and return the parsed fields. The crawler returns `{title, wage, description, job_type, experience_level}`; this endpoint maps `title` to `job_title` in the response and derives `position_type` from the crawler's `title` via `match_skill` (with `description` as additional context). `position_type` is `null` when the crawler returned no title, when the Skill catalog has no match, or when the matcher fails — the remaining crawler fields pass through unchanged in all three cases.
 */
export const hireJobsScrapeByUrlCreate = async (scrapeByUrlInputRequest: ScrapeByUrlInputRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScrapeByUrlResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScrapeByUrlResponse>(getHireJobsScrapeByUrlCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scrapeByUrlInputRequest)
  }
);}





export const getHireJobsScrapeByUrlCreateMutationKey = () => ['hireJobsScrapeByUrlCreate'] as const;

export const getHireJobsScrapeByUrlCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>, TError,HireJobsScrapeByUrlCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>, TError,HireJobsScrapeByUrlCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsScrapeByUrlCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>, HireJobsScrapeByUrlCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireJobsScrapeByUrlCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsScrapeByUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>>
    export type HireJobsScrapeByUrlCreateMutationBody = ScrapeByUrlInputRequest
    export type HireJobsScrapeByUrlCreateMutationError = void
    export type HireJobsScrapeByUrlCreateMutationVariables = {data: ScrapeByUrlInputRequest}

    export const useHireJobsScrapeByUrlCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>, TError,HireJobsScrapeByUrlCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsScrapeByUrlCreate>>,
        TError,
        HireJobsScrapeByUrlCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsScrapeByUrlCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsSkillsListUrl = (params?: HireJobsSkillsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/skills/?${stringifiedParams}` : `/api/hire/jobs/skills/`
}

/**
 * Returns distinct skills that have job postings.
 */
export const hireJobsSkillsList = async (params?: HireJobsSkillsListParams, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingSkill[]> => {

  return customFetch<JobPostingSkill[]>(getHireJobsSkillsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsSkillsListQueryKey = (params?: HireJobsSkillsListParams,) => {
    return [
    `/api/hire/jobs/skills/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsSkillsListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsSkillsList>>, TError = void>(params?: HireJobsSkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsSkillsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsSkillsList>>> = ({ signal }) => hireJobsSkillsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsSkillsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsSkillsList>>>
export type HireJobsSkillsListQueryError = void


export function useHireJobsSkillsList<TData = Awaited<ReturnType<typeof hireJobsSkillsList>>, TError = void>(
 params: undefined |  HireJobsSkillsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsSkillsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsSkillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsSkillsList<TData = Awaited<ReturnType<typeof hireJobsSkillsList>>, TError = void>(
 params?: HireJobsSkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsSkillsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsSkillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsSkillsList<TData = Awaited<ReturnType<typeof hireJobsSkillsList>>, TError = void>(
 params?: HireJobsSkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsSkillsList<TData = Awaited<ReturnType<typeof hireJobsSkillsList>>, TError = void>(
 params?: HireJobsSkillsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsSkillsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireManagerAvailabilityJobsWeekRetrieveUrl = (jobPostingId: string,) => {




  return `/api/hire/manager-availability/jobs/${jobPostingId}/week/`
}

/**
 * Read, replace or clear one posting's availability override.
 *
 * Responses here are ``{is_override, windows}``, not a bare list, because the route answers two
 * questions: what applies, and whether it is the posting's own override or the inherited
 * default. Without the second, a client cannot tell that a GET-tweak-PUT round trip has just
 * converted an inheriting posting into a pinned one.
 *
 * * ``GET`` -- the windows in effect: the posting's override if it has one, else the default of
 *   the manager responsible for it (``hiring_manager``, else ``created_by``).
 * * ``PUT`` -- replace *the posting's* override, leaving every account default untouched. An
 *   empty list clears it, so the posting inherits again and ``is_override`` comes back false.
 * * ``DELETE`` -- drop the override so the posting inherits again. Idempotent: a posting that
 *   was already inheriting still returns 204.
 *
 * The override belongs to the posting, not to the caller: any manager of its location edits the
 * same rows, so a second manager's write replaces the first's rather than shadowing it.
 */
export const hireManagerAvailabilityJobsWeekRetrieve = async (jobPostingId: string, options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityScope> => {

  return customFetch<ManagerAvailabilityScope>(getHireManagerAvailabilityJobsWeekRetrieveUrl(jobPostingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireManagerAvailabilityJobsWeekRetrieveQueryKey = (jobPostingId: string,) => {
    return [
    `/api/hire/manager-availability/jobs/${jobPostingId}/week/`
    ] as const;
    }


export const getHireManagerAvailabilityJobsWeekRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError = void>(jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireManagerAvailabilityJobsWeekRetrieveQueryKey(jobPostingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>> = ({ signal }) => hireManagerAvailabilityJobsWeekRetrieve(jobPostingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireManagerAvailabilityJobsWeekRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>>
export type HireManagerAvailabilityJobsWeekRetrieveQueryError = void


export function useHireManagerAvailabilityJobsWeekRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError = void>(
 jobPostingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityJobsWeekRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityJobsWeekRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireManagerAvailabilityJobsWeekRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireManagerAvailabilityJobsWeekRetrieveQueryOptions(jobPostingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireManagerAvailabilityJobsWeekUpdateUrl = (jobPostingId: string,) => {




  return `/api/hire/manager-availability/jobs/${jobPostingId}/week/`
}

/**
 * Read, replace or clear one posting's availability override.
 *
 * Responses here are ``{is_override, windows}``, not a bare list, because the route answers two
 * questions: what applies, and whether it is the posting's own override or the inherited
 * default. Without the second, a client cannot tell that a GET-tweak-PUT round trip has just
 * converted an inheriting posting into a pinned one.
 *
 * * ``GET`` -- the windows in effect: the posting's override if it has one, else the default of
 *   the manager responsible for it (``hiring_manager``, else ``created_by``).
 * * ``PUT`` -- replace *the posting's* override, leaving every account default untouched. An
 *   empty list clears it, so the posting inherits again and ``is_override`` comes back false.
 * * ``DELETE`` -- drop the override so the posting inherits again. Idempotent: a posting that
 *   was already inheriting still returns 204.
 *
 * The override belongs to the posting, not to the caller: any manager of its location edits the
 * same rows, so a second manager's write replaces the first's rather than shadowing it.
 */
export const hireManagerAvailabilityJobsWeekUpdate = async (jobPostingId: string,
    managerAvailabilityWindowRequest: ManagerAvailabilityWindowRequest[], options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityScope> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerAvailabilityScope>(getHireManagerAvailabilityJobsWeekUpdateUrl(jobPostingId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerAvailabilityWindowRequest)
  }
);}





export const getHireManagerAvailabilityJobsWeekUpdateMutationKey = () => ['hireManagerAvailabilityJobsWeekUpdate'] as const;

export const getHireManagerAvailabilityJobsWeekUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>, TError,HireManagerAvailabilityJobsWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>, TError,HireManagerAvailabilityJobsWeekUpdateMutationVariables, TContext> => {

const mutationKey = getHireManagerAvailabilityJobsWeekUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>, HireManagerAvailabilityJobsWeekUpdateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  hireManagerAvailabilityJobsWeekUpdate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireManagerAvailabilityJobsWeekUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>>
    export type HireManagerAvailabilityJobsWeekUpdateMutationBody = ManagerAvailabilityWindowRequest[]
    export type HireManagerAvailabilityJobsWeekUpdateMutationError = void
    export type HireManagerAvailabilityJobsWeekUpdateMutationVariables = {jobPostingId: string;data: ManagerAvailabilityWindowRequest[]}

    export const useHireManagerAvailabilityJobsWeekUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>, TError,HireManagerAvailabilityJobsWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekUpdate>>,
        TError,
        HireManagerAvailabilityJobsWeekUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireManagerAvailabilityJobsWeekUpdateMutationOptions(options), queryClient);
    }
    export const getHireManagerAvailabilityJobsWeekDestroyUrl = (jobPostingId: string,) => {




  return `/api/hire/manager-availability/jobs/${jobPostingId}/week/`
}

/**
 * Read, replace or clear one posting's availability override.
 *
 * Responses here are ``{is_override, windows}``, not a bare list, because the route answers two
 * questions: what applies, and whether it is the posting's own override or the inherited
 * default. Without the second, a client cannot tell that a GET-tweak-PUT round trip has just
 * converted an inheriting posting into a pinned one.
 *
 * * ``GET`` -- the windows in effect: the posting's override if it has one, else the default of
 *   the manager responsible for it (``hiring_manager``, else ``created_by``).
 * * ``PUT`` -- replace *the posting's* override, leaving every account default untouched. An
 *   empty list clears it, so the posting inherits again and ``is_override`` comes back false.
 * * ``DELETE`` -- drop the override so the posting inherits again. Idempotent: a posting that
 *   was already inheriting still returns 204.
 *
 * The override belongs to the posting, not to the caller: any manager of its location edits the
 * same rows, so a second manager's write replaces the first's rather than shadowing it.
 */
export const hireManagerAvailabilityJobsWeekDestroy = async (jobPostingId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getHireManagerAvailabilityJobsWeekDestroyUrl(jobPostingId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHireManagerAvailabilityJobsWeekDestroyMutationKey = () => ['hireManagerAvailabilityJobsWeekDestroy'] as const;

export const getHireManagerAvailabilityJobsWeekDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>, TError,HireManagerAvailabilityJobsWeekDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>, TError,HireManagerAvailabilityJobsWeekDestroyMutationVariables, TContext> => {

const mutationKey = getHireManagerAvailabilityJobsWeekDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>, HireManagerAvailabilityJobsWeekDestroyMutationVariables> = (props) => {
          const {jobPostingId} = props ?? {};

          return  hireManagerAvailabilityJobsWeekDestroy(jobPostingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireManagerAvailabilityJobsWeekDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>>

    export type HireManagerAvailabilityJobsWeekDestroyMutationError = void
    export type HireManagerAvailabilityJobsWeekDestroyMutationVariables = {jobPostingId: string}

    export const useHireManagerAvailabilityJobsWeekDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>, TError,HireManagerAvailabilityJobsWeekDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireManagerAvailabilityJobsWeekDestroy>>,
        TError,
        HireManagerAvailabilityJobsWeekDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getHireManagerAvailabilityJobsWeekDestroyMutationOptions(options), queryClient);
    }
    export const getHireManagerAvailabilityWeekListUrl = () => {




  return `/api/hire/manager-availability/week/`
}

/**
 * Read or replace the manager's account-level default week.
 *
 * * ``GET`` -- every window in the default scope, unpaginated.
 * * ``PUT`` -- full replace: the posted list becomes the entire week (idempotent). Windows absent
 *   from the payload are cleared; an empty list clears the week.
 *
 * Each window is ``{days_of_week, start_time, end_time}`` with ``days_of_week`` Monday-first
 * (0 = Monday) and ``end_time`` allowed to be ``"24:00"``. Touching and overlapping windows are
 * merged by the service, so the response can hold fewer windows than were posted.
 */
export const hireManagerAvailabilityWeekList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityWindow[]> => {

  return customFetch<ManagerAvailabilityWindow[]>(getHireManagerAvailabilityWeekListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireManagerAvailabilityWeekListQueryKey = () => {
    return [
    `/api/hire/manager-availability/week/`
    ] as const;
    }


export const getHireManagerAvailabilityWeekListQueryOptions = <TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireManagerAvailabilityWeekListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>> = ({ signal }) => hireManagerAvailabilityWeekList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireManagerAvailabilityWeekListQueryResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>>
export type HireManagerAvailabilityWeekListQueryError = void


export function useHireManagerAvailabilityWeekList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireManagerAvailabilityWeekList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireManagerAvailabilityWeekListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireManagerAvailabilityWeekUpdateUrl = () => {




  return `/api/hire/manager-availability/week/`
}

/**
 * Read or replace the manager's account-level default week.
 *
 * * ``GET`` -- every window in the default scope, unpaginated.
 * * ``PUT`` -- full replace: the posted list becomes the entire week (idempotent). Windows absent
 *   from the payload are cleared; an empty list clears the week.
 *
 * Each window is ``{days_of_week, start_time, end_time}`` with ``days_of_week`` Monday-first
 * (0 = Monday) and ``end_time`` allowed to be ``"24:00"``. Touching and overlapping windows are
 * merged by the service, so the response can hold fewer windows than were posted.
 */
export const hireManagerAvailabilityWeekUpdate = async (managerAvailabilityWindowRequest: ManagerAvailabilityWindowRequest[], options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityWindow[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagerAvailabilityWindow[]>(getHireManagerAvailabilityWeekUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managerAvailabilityWindowRequest)
  }
);}





export const getHireManagerAvailabilityWeekUpdateMutationKey = () => ['hireManagerAvailabilityWeekUpdate'] as const;

export const getHireManagerAvailabilityWeekUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>, TError,HireManagerAvailabilityWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>, TError,HireManagerAvailabilityWeekUpdateMutationVariables, TContext> => {

const mutationKey = getHireManagerAvailabilityWeekUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>, HireManagerAvailabilityWeekUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireManagerAvailabilityWeekUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireManagerAvailabilityWeekUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>>
    export type HireManagerAvailabilityWeekUpdateMutationBody = ManagerAvailabilityWindowRequest[]
    export type HireManagerAvailabilityWeekUpdateMutationError = void
    export type HireManagerAvailabilityWeekUpdateMutationVariables = {data: ManagerAvailabilityWindowRequest[]}

    export const useHireManagerAvailabilityWeekUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>, TError,HireManagerAvailabilityWeekUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireManagerAvailabilityWeekUpdate>>,
        TError,
        HireManagerAvailabilityWeekUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireManagerAvailabilityWeekUpdateMutationOptions(options), queryClient);
    }
    export const getHireManagerAvailabilityWeekPreviewListUrl = (params: HireManagerAvailabilityWeekPreviewListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/manager-availability/week/preview/?${stringifiedParams}` : `/api/hire/manager-availability/week/preview/`
}

/**
 * Another manager's account default, for prefilling a job form before the posting exists.
 *
 * The job form copies the responsible manager's windows onto a new posting, so it needs them
 * while the caller is still typing -- and ``jobs/{id}/week/``, the one route that resolves
 * another manager's default, needs a posting that does not exist yet.
 *
 * Deliberately a separate route rather than a ``?hiring_manager=`` parameter on ``week/``: that
 * route's privacy rests on filtering reads to ``request.user.id``, and adding an exception would
 * make every future reader of it responsible for knowing about this one. Read-only, and
 * admission is checked here rather than by the permission class, which is only a coarse
 * "is an employer at all" gate.
 *
 * A target outside the caller's scope is a 404, not a 403, so the route cannot be used to probe
 * which user ids are managers.
 *
 * Returns an empty list when the target has no default: the form shows its empty state, and a
 * manager who has not set availability is not an error.
 */
export const hireManagerAvailabilityWeekPreviewList = async (params: HireManagerAvailabilityWeekPreviewListParams, options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityWindow[]> => {

  return customFetch<ManagerAvailabilityWindow[]>(getHireManagerAvailabilityWeekPreviewListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireManagerAvailabilityWeekPreviewListQueryKey = (params?: HireManagerAvailabilityWeekPreviewListParams,) => {
    return [
    `/api/hire/manager-availability/week/preview/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireManagerAvailabilityWeekPreviewListQueryOptions = <TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError = void>(params: HireManagerAvailabilityWeekPreviewListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireManagerAvailabilityWeekPreviewListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>> = ({ signal }) => hireManagerAvailabilityWeekPreviewList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireManagerAvailabilityWeekPreviewListQueryResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>>
export type HireManagerAvailabilityWeekPreviewListQueryError = void


export function useHireManagerAvailabilityWeekPreviewList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError = void>(
 params: HireManagerAvailabilityWeekPreviewListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekPreviewList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError = void>(
 params: HireManagerAvailabilityWeekPreviewListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekPreviewList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError = void>(
 params: HireManagerAvailabilityWeekPreviewListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireManagerAvailabilityWeekPreviewList<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError = void>(
 params: HireManagerAvailabilityWeekPreviewListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekPreviewList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireManagerAvailabilityWeekPreviewListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireManagerAvailabilityWeekSummaryRetrieveUrl = () => {




  return `/api/hire/manager-availability/week/summary/`
}

/**
 * How many of the caller's open postings this default governs, and how many differ from it.
 *
 * Its own route rather than fields on ``week/``: that route answers with a bare window list so a
 * client can round-trip a ``GET`` straight back into its ``PUT``, and turning it into an object
 * would break that symmetry for every existing consumer.
 *
 * Split by whether a posting's *schedule* matches the default rather than by whether it holds rows
 * of its own, so a posting pinned to exactly the default's week counts as governed by it. The two
 * counts stay disjoint and still sum to the caller's open postings, so they describe
 * ``applies_to + override`` postings in total, not a total and a subset of it.
 *
 * This is deliberately not the question ``jobs/{id}/week/`` answers: that route reports
 * ``is_override=True`` for a posting whose rows duplicate the default, because Reset needs to know
 * rows exist, while this one counts it as applies-to. See ``job_counts_for``.
 *
 * Scoped on the *responsible* manager (``hiring_manager``, else ``created_by``), the same rule
 * ``resolve_for_posting_with_source`` uses, and deliberately NOT ``JobPostingQuerySet.managed_by``:
 * that means "postings this employer may touch", which would count a colleague's postings toward
 * the caller's own default and inflate both numbers for anyone managing a shared location.
 *
 * Only ``request.user.id`` reaches the service, so like ``week/`` this route is strictly the
 * caller's own -- no request field or param can name another manager.
 */
export const hireManagerAvailabilityWeekSummaryRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ManagerAvailabilityJobCounts> => {

  return customFetch<ManagerAvailabilityJobCounts>(getHireManagerAvailabilityWeekSummaryRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireManagerAvailabilityWeekSummaryRetrieveQueryKey = () => {
    return [
    `/api/hire/manager-availability/week/summary/`
    ] as const;
    }


export const getHireManagerAvailabilityWeekSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireManagerAvailabilityWeekSummaryRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>> = ({ signal }) => hireManagerAvailabilityWeekSummaryRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireManagerAvailabilityWeekSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>>
export type HireManagerAvailabilityWeekSummaryRetrieveQueryError = void


export function useHireManagerAvailabilityWeekSummaryRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekSummaryRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireManagerAvailabilityWeekSummaryRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireManagerAvailabilityWeekSummaryRetrieve<TData = Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireManagerAvailabilityWeekSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireManagerAvailabilityWeekSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireScreeningInterviewsListUrl = (params?: HireScreeningInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/screening-interviews/?${stringifiedParams}` : `/api/hire/screening-interviews/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsList = async (params?: HireScreeningInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedScreeningInterviewManagerList> => {

  return customFetch<PaginatedScreeningInterviewManagerList>(getHireScreeningInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireScreeningInterviewsListInfiniteQueryKey = (params?: HireScreeningInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireScreeningInterviewsListQueryKey = (params?: HireScreeningInterviewsListParams,) => {
    return [
    `/api/hire/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireScreeningInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, HireScreeningInterviewsListParams['page']>, TError = void>(params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireScreeningInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, QueryKey, HireScreeningInterviewsListParams['page']> = ({ signal, pageParam }) => hireScreeningInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireScreeningInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsList>>>
export type HireScreeningInterviewsListInfiniteQueryError = void


export function useHireScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, HireScreeningInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireScreeningInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, HireScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, HireScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, HireScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData, QueryKey, HireScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireScreeningInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireScreeningInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError = void>(params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireScreeningInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireScreeningInterviewsList>>> = ({ signal }) => hireScreeningInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireScreeningInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsList>>>
export type HireScreeningInterviewsListQueryError = void


export function useHireScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError = void>(
 params: undefined |  HireScreeningInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError = void>(
 params?: HireScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireScreeningInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireScreeningInterviewsCreateUrl = () => {




  return `/api/hire/screening-interviews/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsCreate = async (screeningInterviewCreateRequest: ScreeningInterviewCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(screeningInterviewCreateRequest)
  }
);}





export const getHireScreeningInterviewsCreateMutationKey = () => ['hireScreeningInterviewsCreate'] as const;

export const getHireScreeningInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>, TError,HireScreeningInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>, TError,HireScreeningInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireScreeningInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>, HireScreeningInterviewsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireScreeningInterviewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireScreeningInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>>
    export type HireScreeningInterviewsCreateMutationBody = ScreeningInterviewCreateRequest
    export type HireScreeningInterviewsCreateMutationError = void
    export type HireScreeningInterviewsCreateMutationVariables = {data: ScreeningInterviewCreateRequest}

    export const useHireScreeningInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>, TError,HireScreeningInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireScreeningInterviewsCreate>>,
        TError,
        HireScreeningInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireScreeningInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireScreeningInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/screening-interviews/${id}/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

  return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireScreeningInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/screening-interviews/${id}/`
    ] as const;
    }


export const getHireScreeningInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireScreeningInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>> = ({ signal }) => hireScreeningInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireScreeningInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>>
export type HireScreeningInterviewsRetrieveQueryError = void


export function useHireScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireScreeningInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireScreeningInterviewsPartialUpdateUrl = (id: string,) => {




  return `/api/hire/screening-interviews/${id}/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsPartialUpdate = async (id: string,
    patchedScreeningInterviewRescheduleRequest?: PatchedScreeningInterviewRescheduleRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedScreeningInterviewRescheduleRequest)
  }
);}





export const getHireScreeningInterviewsPartialUpdateMutationKey = () => ['hireScreeningInterviewsPartialUpdate'] as const;

export const getHireScreeningInterviewsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>, TError,HireScreeningInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>, TError,HireScreeningInterviewsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireScreeningInterviewsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>, HireScreeningInterviewsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireScreeningInterviewsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireScreeningInterviewsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>>
    export type HireScreeningInterviewsPartialUpdateMutationBody = PatchedScreeningInterviewRescheduleRequest | undefined
    export type HireScreeningInterviewsPartialUpdateMutationError = void
    export type HireScreeningInterviewsPartialUpdateMutationVariables = {id: string;data?: PatchedScreeningInterviewRescheduleRequest}

    export const useHireScreeningInterviewsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>, TError,HireScreeningInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireScreeningInterviewsPartialUpdate>>,
        TError,
        HireScreeningInterviewsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireScreeningInterviewsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireScreeningInterviewsCancellationsCreateUrl = (id: string,) => {




  return `/api/hire/screening-interviews/${id}/cancellations/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsCancellationsCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

  return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsCancellationsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireScreeningInterviewsCancellationsCreateMutationKey = () => ['hireScreeningInterviewsCancellationsCreate'] as const;

export const getHireScreeningInterviewsCancellationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>, TError,HireScreeningInterviewsCancellationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>, TError,HireScreeningInterviewsCancellationsCreateMutationVariables, TContext> => {

const mutationKey = getHireScreeningInterviewsCancellationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>, HireScreeningInterviewsCancellationsCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireScreeningInterviewsCancellationsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireScreeningInterviewsCancellationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>>

    export type HireScreeningInterviewsCancellationsCreateMutationError = void
    export type HireScreeningInterviewsCancellationsCreateMutationVariables = {id: string}

    export const useHireScreeningInterviewsCancellationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>, TError,HireScreeningInterviewsCancellationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireScreeningInterviewsCancellationsCreate>>,
        TError,
        HireScreeningInterviewsCancellationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireScreeningInterviewsCancellationsCreateMutationOptions(options), queryClient);
    }
    export const getHireScreeningInterviewsFeedbackUpdateUrl = (id: string,) => {




  return `/api/hire/screening-interviews/${id}/feedback/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsFeedbackUpdate = async (id: string,
    screeningInterviewFeedbackRequest: ScreeningInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsFeedbackUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(screeningInterviewFeedbackRequest)
  }
);}





export const getHireScreeningInterviewsFeedbackUpdateMutationKey = () => ['hireScreeningInterviewsFeedbackUpdate'] as const;

export const getHireScreeningInterviewsFeedbackUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>, TError,HireScreeningInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>, TError,HireScreeningInterviewsFeedbackUpdateMutationVariables, TContext> => {

const mutationKey = getHireScreeningInterviewsFeedbackUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>, HireScreeningInterviewsFeedbackUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireScreeningInterviewsFeedbackUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireScreeningInterviewsFeedbackUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>>
    export type HireScreeningInterviewsFeedbackUpdateMutationBody = ScreeningInterviewFeedbackRequest
    export type HireScreeningInterviewsFeedbackUpdateMutationError = void
    export type HireScreeningInterviewsFeedbackUpdateMutationVariables = {id: string;data: ScreeningInterviewFeedbackRequest}

    export const useHireScreeningInterviewsFeedbackUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>, TError,HireScreeningInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackUpdate>>,
        TError,
        HireScreeningInterviewsFeedbackUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireScreeningInterviewsFeedbackUpdateMutationOptions(options), queryClient);
    }
    export const getHireScreeningInterviewsFeedbackPartialUpdateUrl = (id: string,) => {




  return `/api/hire/screening-interviews/${id}/feedback/`
}

/**
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 */
export const hireScreeningInterviewsFeedbackPartialUpdate = async (id: string,
    patchedScreeningInterviewFeedbackRequest?: PatchedScreeningInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireScreeningInterviewsFeedbackPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedScreeningInterviewFeedbackRequest)
  }
);}





export const getHireScreeningInterviewsFeedbackPartialUpdateMutationKey = () => ['hireScreeningInterviewsFeedbackPartialUpdate'] as const;

export const getHireScreeningInterviewsFeedbackPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>, TError,HireScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>, TError,HireScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireScreeningInterviewsFeedbackPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>, HireScreeningInterviewsFeedbackPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireScreeningInterviewsFeedbackPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireScreeningInterviewsFeedbackPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>>
    export type HireScreeningInterviewsFeedbackPartialUpdateMutationBody = PatchedScreeningInterviewFeedbackRequest | undefined
    export type HireScreeningInterviewsFeedbackPartialUpdateMutationError = void
    export type HireScreeningInterviewsFeedbackPartialUpdateMutationVariables = {id: string;data?: PatchedScreeningInterviewFeedbackRequest}

    export const useHireScreeningInterviewsFeedbackPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>, TError,HireScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireScreeningInterviewsFeedbackPartialUpdate>>,
        TError,
        HireScreeningInterviewsFeedbackPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireScreeningInterviewsFeedbackPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsListUrl = (params?: HireStafferInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/interviews/?${stringifiedParams}` : `/api/hire/staffer/interviews/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsList = async (params?: HireStafferInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireStafferInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsListInfiniteQueryKey = (params?: HireStafferInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/staffer/interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireStafferInterviewsListQueryKey = (params?: HireStafferInterviewsListParams,) => {
    return [
    `/api/hire/staffer/interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsList>>, HireStafferInterviewsListParams['page']>, TError = void>(params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsList>>, QueryKey, HireStafferInterviewsListParams['page']> = ({ signal, pageParam }) => hireStafferInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsList>>>
export type HireStafferInterviewsListInfiniteQueryError = void


export function useHireStafferInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsList>>, HireStafferInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireStafferInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsList>>, HireStafferInterviewsListParams['page']>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsList>>, HireStafferInterviewsListParams['page']>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsList>>, HireStafferInterviewsListParams['page']>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData, QueryKey, HireStafferInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError = void>(params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsList>>> = ({ signal }) => hireStafferInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsList>>>
export type HireStafferInterviewsListQueryError = void


export function useHireStafferInterviewsList<TData = Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError = void>(
 params: undefined |  HireStafferInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsList<TData = Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsList<TData = Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsList<TData = Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError = void>(
 params?: HireStafferInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsCreateUrl = () => {




  return `/api/hire/staffer/interviews/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsCreate = async (interviewDTORequest: InterviewDTORequest, options?: Parameters<typeof customFetch>[1]): Promise<InterviewDTO> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewDTO>(getHireStafferInterviewsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interviewDTORequest)
  }
);}





export const getHireStafferInterviewsCreateMutationKey = () => ['hireStafferInterviewsCreate'] as const;

export const getHireStafferInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsCreate>>, TError,HireStafferInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsCreate>>, TError,HireStafferInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsCreate>>, HireStafferInterviewsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireStafferInterviewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsCreate>>>
    export type HireStafferInterviewsCreateMutationBody = InterviewDTORequest
    export type HireStafferInterviewsCreateMutationError = void
    export type HireStafferInterviewsCreateMutationVariables = {data: InterviewDTORequest}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsCreate>>, TError,HireStafferInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsCreate>>,
        TError,
        HireStafferInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsHiringScheduleListUrl = (params: HireStafferInterviewsHiringScheduleListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/interviews/hiring-schedule/?${stringifiedParams}` : `/api/hire/staffer/interviews/hiring-schedule/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Interview "shifts" for a location's OPEN job postings within a week window.
 *
 * Powers the business Hiring Schedule week grid (CORE-6259/6488). Returns offered (``INVITED``),
 * confirmed, and terminal (``DECLINED`` / ``CANCELLED``) items; the FE renders/filters the grid
 * client-side off each card's ``kind`` / ``status`` / ``fill_state``. Filters on each item's own
 * ``start_time`` (not the gig-stage time) so offered interviews with no gig yet are included.
 * Unpaginated array shaped for the marketplace calendar's event contract; every item carries
 * ``kind``.
 *
 * Two kinds share the feed: working (trial-shift) ``Interview``s and phone/video/in-person
 * ``ScreeningInterview``s (CORE-6488), merged and sorted by ``start_time``.
 * @deprecated
 */
export const hireStafferInterviewsHiringScheduleList = async (params: HireStafferInterviewsHiringScheduleListParams, options?: Parameters<typeof customFetch>[1]): Promise<HiringScheduleItem[]> => {

  return customFetch<HiringScheduleItem[]>(getHireStafferInterviewsHiringScheduleListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsHiringScheduleListQueryKey = (params?: HireStafferInterviewsHiringScheduleListParams,) => {
    return [
    `/api/hire/staffer/interviews/hiring-schedule/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferInterviewsHiringScheduleListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError = void>(params: HireStafferInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsHiringScheduleListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>> = ({ signal }) => hireStafferInterviewsHiringScheduleList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsHiringScheduleListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>>
export type HireStafferInterviewsHiringScheduleListQueryError = void


export function useHireStafferInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError = void>(
 params: HireStafferInterviewsHiringScheduleListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError = void>(
 params: HireStafferInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError = void>(
 params: HireStafferInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsHiringScheduleList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError = void>(
 params: HireStafferInterviewsHiringScheduleListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHiringScheduleList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsHiringScheduleListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsHistoryListUrl = (params?: HireStafferInterviewsHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/interviews/history/?${stringifiedParams}` : `/api/hire/staffer/interviews/history/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Convenience endpoint to list staffer's historic interviews.
 * @deprecated
 */
export const hireStafferInterviewsHistoryList = async (params?: HireStafferInterviewsHistoryListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireStafferInterviewsHistoryListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsHistoryListInfiniteQueryKey = (params?: HireStafferInterviewsHistoryListParams,) => {
    return [
    'infinite', `/api/hire/staffer/interviews/history/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireStafferInterviewsHistoryListQueryKey = (params?: HireStafferInterviewsHistoryListParams,) => {
    return [
    `/api/hire/staffer/interviews/history/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferInterviewsHistoryListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, HireStafferInterviewsHistoryListParams['page']>, TError = void>(params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsHistoryListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, QueryKey, HireStafferInterviewsHistoryListParams['page']> = ({ signal, pageParam }) => hireStafferInterviewsHistoryList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsHistoryListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>>
export type HireStafferInterviewsHistoryListInfiniteQueryError = void


export function useHireStafferInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, HireStafferInterviewsHistoryListParams['page']>, TError = void>(
 params: undefined |  HireStafferInterviewsHistoryListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, HireStafferInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, HireStafferInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsHistoryListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, HireStafferInterviewsHistoryListParams['page']>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData, QueryKey, HireStafferInterviewsHistoryListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsHistoryListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError = void>(params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsHistoryListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>> = ({ signal }) => hireStafferInterviewsHistoryList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>>
export type HireStafferInterviewsHistoryListQueryError = void


export function useHireStafferInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError = void>(
 params: undefined |  HireStafferInterviewsHistoryListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsHistoryList<TData = Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError = void>(
 params?: HireStafferInterviewsHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsHistoryListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsPayDueListUrl = (params?: HireStafferInterviewsPayDueListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/interviews/pay-due/?${stringifiedParams}` : `/api/hire/staffer/interviews/pay-due/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Convenience endpoint to list staffer's pay due interviews.
 * @deprecated
 */
export const hireStafferInterviewsPayDueList = async (params?: HireStafferInterviewsPayDueListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireStafferInterviewsPayDueListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsPayDueListInfiniteQueryKey = (params?: HireStafferInterviewsPayDueListParams,) => {
    return [
    'infinite', `/api/hire/staffer/interviews/pay-due/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireStafferInterviewsPayDueListQueryKey = (params?: HireStafferInterviewsPayDueListParams,) => {
    return [
    `/api/hire/staffer/interviews/pay-due/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferInterviewsPayDueListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, HireStafferInterviewsPayDueListParams['page']>, TError = void>(params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsPayDueListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, QueryKey, HireStafferInterviewsPayDueListParams['page']> = ({ signal, pageParam }) => hireStafferInterviewsPayDueList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsPayDueListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>>
export type HireStafferInterviewsPayDueListInfiniteQueryError = void


export function useHireStafferInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, HireStafferInterviewsPayDueListParams['page']>, TError = void>(
 params: undefined |  HireStafferInterviewsPayDueListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, HireStafferInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, HireStafferInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsPayDueListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, HireStafferInterviewsPayDueListParams['page']>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData, QueryKey, HireStafferInterviewsPayDueListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsPayDueListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsPayDueListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError = void>(params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsPayDueListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>> = ({ signal }) => hireStafferInterviewsPayDueList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsPayDueListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>>
export type HireStafferInterviewsPayDueListQueryError = void


export function useHireStafferInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError = void>(
 params: undefined |  HireStafferInterviewsPayDueListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsPayDueList<TData = Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError = void>(
 params?: HireStafferInterviewsPayDueListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsPayDueList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsPayDueListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsUpcomingListUrl = (params?: HireStafferInterviewsUpcomingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/interviews/upcoming/?${stringifiedParams}` : `/api/hire/staffer/interviews/upcoming/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Convenience endpoint to list staffer's upcoming interviews.
 * @deprecated
 */
export const hireStafferInterviewsUpcomingList = async (params?: HireStafferInterviewsUpcomingListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedInterviewManagerList> => {

  return customFetch<PaginatedInterviewManagerList>(getHireStafferInterviewsUpcomingListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsUpcomingListInfiniteQueryKey = (params?: HireStafferInterviewsUpcomingListParams,) => {
    return [
    'infinite', `/api/hire/staffer/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireStafferInterviewsUpcomingListQueryKey = (params?: HireStafferInterviewsUpcomingListParams,) => {
    return [
    `/api/hire/staffer/interviews/upcoming/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferInterviewsUpcomingListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, HireStafferInterviewsUpcomingListParams['page']>, TError = void>(params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsUpcomingListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, QueryKey, HireStafferInterviewsUpcomingListParams['page']> = ({ signal, pageParam }) => hireStafferInterviewsUpcomingList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsUpcomingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>>
export type HireStafferInterviewsUpcomingListInfiniteQueryError = void


export function useHireStafferInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, HireStafferInterviewsUpcomingListParams['page']>, TError = void>(
 params: undefined |  HireStafferInterviewsUpcomingListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, HireStafferInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, HireStafferInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsUpcomingListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, HireStafferInterviewsUpcomingListParams['page']>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData, QueryKey, HireStafferInterviewsUpcomingListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsUpcomingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsUpcomingListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError = void>(params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsUpcomingListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>> = ({ signal }) => hireStafferInterviewsUpcomingList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsUpcomingListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>>
export type HireStafferInterviewsUpcomingListQueryError = void


export function useHireStafferInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError = void>(
 params: undefined |  HireStafferInterviewsUpcomingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsUpcomingList<TData = Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError = void>(
 params?: HireStafferInterviewsUpcomingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsUpcomingList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsUpcomingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsReviewsCreateUrl = (interviewId: string,) => {




  return `/api/hire/staffer/interviews/${interviewId}/reviews/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsReviewsCreate = async (interviewId: string,
    stafferReviewRequest: StafferReviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferReview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferReview>(getHireStafferInterviewsReviewsCreateUrl(interviewId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stafferReviewRequest)
  }
);}





export const getHireStafferInterviewsReviewsCreateMutationKey = () => ['hireStafferInterviewsReviewsCreate'] as const;

export const getHireStafferInterviewsReviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>, TError,HireStafferInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>, TError,HireStafferInterviewsReviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsReviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>, HireStafferInterviewsReviewsCreateMutationVariables> = (props) => {
          const {interviewId,data} = props ?? {};

          return  hireStafferInterviewsReviewsCreate(interviewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>>
    export type HireStafferInterviewsReviewsCreateMutationBody = StafferReviewRequest
    export type HireStafferInterviewsReviewsCreateMutationError = void
    export type HireStafferInterviewsReviewsCreateMutationVariables = {interviewId: string;data: StafferReviewRequest}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsReviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>, TError,HireStafferInterviewsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsReviewsCreate>>,
        TError,
        HireStafferInterviewsReviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsReviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/staffer/interviews/${id}/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireStafferInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/staffer/interviews/${id}/`
    ] as const;
    }


export const getHireStafferInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>> = ({ signal }) => hireStafferInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>>
export type HireStafferInterviewsRetrieveQueryError = void


export function useHireStafferInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferInterviewsFeedbackUpdateUrl = (id: string,) => {




  return `/api/hire/staffer/interviews/${id}/feedback/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsFeedbackUpdate = async (id: string,
    interviewFeedbackRequest: InterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtendedInterviewManager>(getHireStafferInterviewsFeedbackUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interviewFeedbackRequest)
  }
);}





export const getHireStafferInterviewsFeedbackUpdateMutationKey = () => ['hireStafferInterviewsFeedbackUpdate'] as const;

export const getHireStafferInterviewsFeedbackUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>, TError,HireStafferInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>, TError,HireStafferInterviewsFeedbackUpdateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsFeedbackUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>, HireStafferInterviewsFeedbackUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireStafferInterviewsFeedbackUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsFeedbackUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>>
    export type HireStafferInterviewsFeedbackUpdateMutationBody = InterviewFeedbackRequest
    export type HireStafferInterviewsFeedbackUpdateMutationError = void
    export type HireStafferInterviewsFeedbackUpdateMutationVariables = {id: string;data: InterviewFeedbackRequest}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsFeedbackUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>, TError,HireStafferInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsFeedbackUpdate>>,
        TError,
        HireStafferInterviewsFeedbackUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsFeedbackUpdateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsFeedbackPartialUpdateUrl = (id: string,) => {




  return `/api/hire/staffer/interviews/${id}/feedback/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Bind the location / job-posting scope inputs -- rejecting a malformed one with 400 -- between
 * authentication and the scope-based authorization check that consumes them (CORE-6874).
 *
 * ORDER, stated precisely, because "validation before authorization" would be the wrong general
 * rule and is NOT what this does:
 *
 *     authenticate  ->  bind the inputs authorization consumes  ->  authorize
 *
 * Authentication stays first, always. What sits between authn and authz here is only the binding of
 * the two values the authorization decision is parameterized by. This is the standard shape for
 * resource/attribute-scoped authorization -- the same reason Spring evaluates ``@PreAuthorize`` on
 * already-bound arguments and ASP.NET does resource-based ``AuthorizeAsync`` after model binding.
 * Authorization that depends only on identity and route still runs first, untouched: every
 * permission class on these viewsets is behind ``super().check_permissions``.
 *
 * WHY IT CANNOT BE DONE INSIDE THE PERMISSION CLASSES INSTEAD. ``get_permissions`` branches on the
 * actor's shape, so anything downstream of it can answer differently per actor. Coercing inside the
 * consumers turns the old uniform 500 into 403 for a manager and 200-empty for an admin -- the
 * crash is gone but the divergence is not. A single answer for a malformed request requires the
 * check to precede the permission classes; there is no arrangement inside them that gets there.
 *
 * WHY IT HAS TO RUN HERE. These inputs are read by TWO consumers -- the permission class and
 * ``get_queryset`` -- and which one a request reaches depends on the caller's role
 * (``get_permissions`` routes an admin-only actor away from ``InterviewManagerPermission``
 * entirely). Guarding either consumer alone therefore fixes the crash for some callers and leaves
 * it for others, which is strictly worse than the uniform 500 it replaces. One check in front of
 * both is the only shape that gives every actor the same answer.
 *
 * WHY ``check_permissions`` AND NOT ``initial``. ``check_permissions`` is the last hook that still
 * precedes both consumers (``filter_queryset`` and the handler run much later, so a ``FilterSet``
 * cannot help). Overriding ``initial`` to splice a step between its calls would mean copying DRF
 * internals.
 *
 * ORDERING NOTE -- read this before moving the call. ``APIView.perform_authentication`` does NOT
 * reject anonymous callers; its entire body is ``request.user``. The 401 comes from
 * ``IsAuthenticated`` INSIDE ``check_permissions``. So validating unconditionally here would run
 * ahead of the authentication gate and turn an anonymous caller's 401 into a 400 -- leaking that a
 * param was malformed to a caller who is not authenticated to ask anything. Hence the
 * ``is_authenticated`` guard below: unauthenticated requests fall straight through to ``super()``,
 * keeping their 401. Pinned by ``test_anonymous_caller_still_gets_401_not_400``.
 *
 * SCOPE: THE TWO STAFFER VIEWSETS ONLY. Applied where these inputs feed an AUTHORIZATION decision,
 * which is what forces the check ahead of the permission classes. A viewset that merely *filters* on
 * the header has no such ordering constraint and should call ``validate_location_id_header`` at its
 * point of use instead -- see ``CandidateInterviewViewSet.apply_internal_filters``. Mixing this in
 * there would 400 every action on the viewset, including ``confirmations`` / ``reviews`` /
 * ``phone-number-lookup``, none of which read the header at all.
 *
 * Covers every action on the staffer viewsets, including writes. That is deliberate and not a
 * per-action carve-out: ``StafferScreeningInterviewViewSet.partial_update`` IS a write and DOES
 * reach the header, via ``get_object()`` -> ``get_queryset()`` -> ``.filter(job_posting__location_id
 * =...)``, so gating on safe methods would re-open a live 500 on screening reschedule.
 *
 * WRITE-PATH WIDENING -- ACCEPTED, stated so it is a choice rather than a side effect. On the
 * interview surface ``POST /api/hire/interviews/`` with a malformed header (or ``?location_id=``)
 * was a 201 and is now a 400: ``create`` never touches ``get_queryset``, and
 * ``InterviewManagerPermission.has_permission`` short-circuits ``True`` for non-safe methods, so
 * there was no crash there to fix. Kept because the alternative is the method-by-method carve-out
 * above, which leaves a real 500 live. The 400 is declared on every write operation that can emit
 * it.
 *
 * EMPTY VALUES ARE TREATED AS ABSENT, on purpose. ``?location_id=`` yields ``''``, which the field
 * would reject -- but both prior consumers guarded with a falsy check (``if location_id``) and
 * returned an unfiltered 200. Turning that into a 400 would be a real behavior change for any
 * client that emits empty query strings, and it is not the defect being fixed here.
 * @deprecated
 */
export const hireStafferInterviewsFeedbackPartialUpdate = async (id: string,
    patchedInterviewFeedbackRequest?: PatchedInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ExtendedInterviewManager>(getHireStafferInterviewsFeedbackPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedInterviewFeedbackRequest)
  }
);}





export const getHireStafferInterviewsFeedbackPartialUpdateMutationKey = () => ['hireStafferInterviewsFeedbackPartialUpdate'] as const;

export const getHireStafferInterviewsFeedbackPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>, TError,HireStafferInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>, TError,HireStafferInterviewsFeedbackPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsFeedbackPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>, HireStafferInterviewsFeedbackPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireStafferInterviewsFeedbackPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsFeedbackPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>>
    export type HireStafferInterviewsFeedbackPartialUpdateMutationBody = PatchedInterviewFeedbackRequest | undefined
    export type HireStafferInterviewsFeedbackPartialUpdateMutationError = void
    export type HireStafferInterviewsFeedbackPartialUpdateMutationVariables = {id: string;data?: PatchedInterviewFeedbackRequest}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsFeedbackPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>, TError,HireStafferInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsFeedbackPartialUpdate>>,
        TError,
        HireStafferInterviewsFeedbackPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsFeedbackPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsPassCreateUrl = (id: string,) => {




  return `/api/hire/staffer/interviews/${id}/pass/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Pass on the Pro after a tryout that happened: records the manager's PASS review, so the tryout no longer counts as having gone well, and logs it to the job's activity. 400 when the interview is not reviewable or was already reviewed. 404 when the working-interview feature is off for the location.
 * @deprecated
 */
export const hireStafferInterviewsPassCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireStafferInterviewsPassCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireStafferInterviewsPassCreateMutationKey = () => ['hireStafferInterviewsPassCreate'] as const;

export const getHireStafferInterviewsPassCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>, TError,HireStafferInterviewsPassCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>, TError,HireStafferInterviewsPassCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsPassCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>, HireStafferInterviewsPassCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireStafferInterviewsPassCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsPassCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>>

    export type HireStafferInterviewsPassCreateMutationError = void
    export type HireStafferInterviewsPassCreateMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsPassCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>, TError,HireStafferInterviewsPassCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsPassCreate>>,
        TError,
        HireStafferInterviewsPassCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsPassCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferInterviewsRemoveCreateUrl = (id: string,) => {




  return `/api/hire/staffer/interviews/${id}/remove/`
}

/**
 * Deprecated — use /api/hire/interviews/ instead. Behaviour is identical.
 *
 * Remove a booked Pro before the shift starts: cancels their tryout, reopens the seat and logs it to the job's activity. 400 when the Pro is not booked or the shift has started. 404 when the working-interview feature is off for the location.
 * @deprecated
 */
export const hireStafferInterviewsRemoveCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExtendedInterviewManager> => {

  return customFetch<ExtendedInterviewManager>(getHireStafferInterviewsRemoveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireStafferInterviewsRemoveCreateMutationKey = () => ['hireStafferInterviewsRemoveCreate'] as const;

export const getHireStafferInterviewsRemoveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>, TError,HireStafferInterviewsRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>, TError,HireStafferInterviewsRemoveCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferInterviewsRemoveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>, HireStafferInterviewsRemoveCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireStafferInterviewsRemoveCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferInterviewsRemoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>>

    export type HireStafferInterviewsRemoveCreateMutationError = void
    export type HireStafferInterviewsRemoveCreateMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useHireStafferInterviewsRemoveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>, TError,HireStafferInterviewsRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferInterviewsRemoveCreate>>,
        TError,
        HireStafferInterviewsRemoveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferInterviewsRemoveCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferScreeningInterviewsListUrl = (params?: HireStafferScreeningInterviewsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/staffer/screening-interviews/?${stringifiedParams}` : `/api/hire/staffer/screening-interviews/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsList = async (params?: HireStafferScreeningInterviewsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedScreeningInterviewManagerList> => {

  return customFetch<PaginatedScreeningInterviewManagerList>(getHireStafferScreeningInterviewsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferScreeningInterviewsListInfiniteQueryKey = (params?: HireStafferScreeningInterviewsListParams,) => {
    return [
    'infinite', `/api/hire/staffer/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireStafferScreeningInterviewsListQueryKey = (params?: HireStafferScreeningInterviewsListParams,) => {
    return [
    `/api/hire/staffer/screening-interviews/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireStafferScreeningInterviewsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, HireStafferScreeningInterviewsListParams['page']>, TError = void>(params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferScreeningInterviewsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, QueryKey, HireStafferScreeningInterviewsListParams['page']> = ({ signal, pageParam }) => hireStafferScreeningInterviewsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferScreeningInterviewsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>>
export type HireStafferScreeningInterviewsListInfiniteQueryError = void


export function useHireStafferScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, HireStafferScreeningInterviewsListParams['page']>, TError = void>(
 params: undefined |  HireStafferScreeningInterviewsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, HireStafferScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, HireStafferScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferScreeningInterviewsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, HireStafferScreeningInterviewsListParams['page']>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData, QueryKey, HireStafferScreeningInterviewsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferScreeningInterviewsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferScreeningInterviewsListQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError = void>(params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferScreeningInterviewsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>> = ({ signal }) => hireStafferScreeningInterviewsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferScreeningInterviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>>
export type HireStafferScreeningInterviewsListQueryError = void


export function useHireStafferScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError = void>(
 params: undefined |  HireStafferScreeningInterviewsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferScreeningInterviewsList<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError = void>(
 params?: HireStafferScreeningInterviewsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferScreeningInterviewsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferScreeningInterviewsCreateUrl = () => {




  return `/api/hire/staffer/screening-interviews/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsCreate = async (screeningInterviewCreateRequest: ScreeningInterviewCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(screeningInterviewCreateRequest)
  }
);}





export const getHireStafferScreeningInterviewsCreateMutationKey = () => ['hireStafferScreeningInterviewsCreate'] as const;

export const getHireStafferScreeningInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>, TError,HireStafferScreeningInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>, TError,HireStafferScreeningInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferScreeningInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>, HireStafferScreeningInterviewsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireStafferScreeningInterviewsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferScreeningInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>>
    export type HireStafferScreeningInterviewsCreateMutationBody = ScreeningInterviewCreateRequest
    export type HireStafferScreeningInterviewsCreateMutationError = void
    export type HireStafferScreeningInterviewsCreateMutationVariables = {data: ScreeningInterviewCreateRequest}

    /**
 * @deprecated
 */
export const useHireStafferScreeningInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>, TError,HireStafferScreeningInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferScreeningInterviewsCreate>>,
        TError,
        HireStafferScreeningInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferScreeningInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferScreeningInterviewsRetrieveUrl = (id: string,) => {




  return `/api/hire/staffer/screening-interviews/${id}/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

  return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireStafferScreeningInterviewsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/staffer/screening-interviews/${id}/`
    ] as const;
    }


export const getHireStafferScreeningInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireStafferScreeningInterviewsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>> = ({ signal }) => hireStafferScreeningInterviewsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireStafferScreeningInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>>
export type HireStafferScreeningInterviewsRetrieveQueryError = void


export function useHireStafferScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireStafferScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useHireStafferScreeningInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireStafferScreeningInterviewsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireStafferScreeningInterviewsPartialUpdateUrl = (id: string,) => {




  return `/api/hire/staffer/screening-interviews/${id}/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsPartialUpdate = async (id: string,
    patchedScreeningInterviewRescheduleRequest?: PatchedScreeningInterviewRescheduleRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedScreeningInterviewRescheduleRequest)
  }
);}





export const getHireStafferScreeningInterviewsPartialUpdateMutationKey = () => ['hireStafferScreeningInterviewsPartialUpdate'] as const;

export const getHireStafferScreeningInterviewsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>, TError,HireStafferScreeningInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>, TError,HireStafferScreeningInterviewsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireStafferScreeningInterviewsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>, HireStafferScreeningInterviewsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireStafferScreeningInterviewsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferScreeningInterviewsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>>
    export type HireStafferScreeningInterviewsPartialUpdateMutationBody = PatchedScreeningInterviewRescheduleRequest | undefined
    export type HireStafferScreeningInterviewsPartialUpdateMutationError = void
    export type HireStafferScreeningInterviewsPartialUpdateMutationVariables = {id: string;data?: PatchedScreeningInterviewRescheduleRequest}

    /**
 * @deprecated
 */
export const useHireStafferScreeningInterviewsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>, TError,HireStafferScreeningInterviewsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferScreeningInterviewsPartialUpdate>>,
        TError,
        HireStafferScreeningInterviewsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferScreeningInterviewsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireStafferScreeningInterviewsCancellationsCreateUrl = (id: string,) => {




  return `/api/hire/staffer/screening-interviews/${id}/cancellations/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsCancellationsCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

  return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsCancellationsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireStafferScreeningInterviewsCancellationsCreateMutationKey = () => ['hireStafferScreeningInterviewsCancellationsCreate'] as const;

export const getHireStafferScreeningInterviewsCancellationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>, TError,HireStafferScreeningInterviewsCancellationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>, TError,HireStafferScreeningInterviewsCancellationsCreateMutationVariables, TContext> => {

const mutationKey = getHireStafferScreeningInterviewsCancellationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>, HireStafferScreeningInterviewsCancellationsCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireStafferScreeningInterviewsCancellationsCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferScreeningInterviewsCancellationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>>

    export type HireStafferScreeningInterviewsCancellationsCreateMutationError = void
    export type HireStafferScreeningInterviewsCancellationsCreateMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useHireStafferScreeningInterviewsCancellationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>, TError,HireStafferScreeningInterviewsCancellationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferScreeningInterviewsCancellationsCreate>>,
        TError,
        HireStafferScreeningInterviewsCancellationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferScreeningInterviewsCancellationsCreateMutationOptions(options), queryClient);
    }
    export const getHireStafferScreeningInterviewsFeedbackUpdateUrl = (id: string,) => {




  return `/api/hire/staffer/screening-interviews/${id}/feedback/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsFeedbackUpdate = async (id: string,
    screeningInterviewFeedbackRequest: ScreeningInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsFeedbackUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(screeningInterviewFeedbackRequest)
  }
);}





export const getHireStafferScreeningInterviewsFeedbackUpdateMutationKey = () => ['hireStafferScreeningInterviewsFeedbackUpdate'] as const;

export const getHireStafferScreeningInterviewsFeedbackUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>, TError,HireStafferScreeningInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>, TError,HireStafferScreeningInterviewsFeedbackUpdateMutationVariables, TContext> => {

const mutationKey = getHireStafferScreeningInterviewsFeedbackUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>, HireStafferScreeningInterviewsFeedbackUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireStafferScreeningInterviewsFeedbackUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferScreeningInterviewsFeedbackUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>>
    export type HireStafferScreeningInterviewsFeedbackUpdateMutationBody = ScreeningInterviewFeedbackRequest
    export type HireStafferScreeningInterviewsFeedbackUpdateMutationError = void
    export type HireStafferScreeningInterviewsFeedbackUpdateMutationVariables = {id: string;data: ScreeningInterviewFeedbackRequest}

    /**
 * @deprecated
 */
export const useHireStafferScreeningInterviewsFeedbackUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>, TError,HireStafferScreeningInterviewsFeedbackUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackUpdate>>,
        TError,
        HireStafferScreeningInterviewsFeedbackUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferScreeningInterviewsFeedbackUpdateMutationOptions(options), queryClient);
    }
    export const getHireStafferScreeningInterviewsFeedbackPartialUpdateUrl = (id: string,) => {




  return `/api/hire/staffer/screening-interviews/${id}/feedback/`
}

/**
 * Deprecated — use /api/hire/screening-interviews/ instead. Behaviour is identical.
 *
 * Business-side: schedule, list, retrieve and cancel phone/video/in-person screening interviews.
 * @deprecated
 */
export const hireStafferScreeningInterviewsFeedbackPartialUpdate = async (id: string,
    patchedScreeningInterviewFeedbackRequest?: PatchedScreeningInterviewFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<ScreeningInterviewManager> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScreeningInterviewManager>(getHireStafferScreeningInterviewsFeedbackPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedScreeningInterviewFeedbackRequest)
  }
);}





export const getHireStafferScreeningInterviewsFeedbackPartialUpdateMutationKey = () => ['hireStafferScreeningInterviewsFeedbackPartialUpdate'] as const;

export const getHireStafferScreeningInterviewsFeedbackPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>, TError,HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>, TError,HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireStafferScreeningInterviewsFeedbackPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>, HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireStafferScreeningInterviewsFeedbackPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireStafferScreeningInterviewsFeedbackPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>>
    export type HireStafferScreeningInterviewsFeedbackPartialUpdateMutationBody = PatchedScreeningInterviewFeedbackRequest | undefined
    export type HireStafferScreeningInterviewsFeedbackPartialUpdateMutationError = void
    export type HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables = {id: string;data?: PatchedScreeningInterviewFeedbackRequest}

    /**
 * @deprecated
 */
export const useHireStafferScreeningInterviewsFeedbackPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>, TError,HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireStafferScreeningInterviewsFeedbackPartialUpdate>>,
        TError,
        HireStafferScreeningInterviewsFeedbackPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireStafferScreeningInterviewsFeedbackPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireUsersCreateUrl = () => {




  return `/api/hire/users/`
}

export const hireUsersCreate = async (hireUserRequest: HireUserRequest, options?: Parameters<typeof customFetch>[1]): Promise<HireUser> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<HireUser>(getHireUsersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(hireUserRequest)
  }
);}





export const getHireUsersCreateMutationKey = () => ['hireUsersCreate'] as const;

export const getHireUsersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersCreate>>, TError,HireUsersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireUsersCreate>>, TError,HireUsersCreateMutationVariables, TContext> => {

const mutationKey = getHireUsersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireUsersCreate>>, HireUsersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireUsersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireUsersCreate>>>
    export type HireUsersCreateMutationBody = HireUserRequest
    export type HireUsersCreateMutationError = void
    export type HireUsersCreateMutationVariables = {data: HireUserRequest}

    export const useHireUsersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersCreate>>, TError,HireUsersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireUsersCreate>>,
        TError,
        HireUsersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireUsersCreateMutationOptions(options), queryClient);
    }
    export const getHireUsersRetrieveUrl = (id: number | 'me',) => {




  return `/api/hire/users/${id}/`
}

export const hireUsersRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<HireUser> => {

  return customFetch<HireUser>(getHireUsersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireUsersRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/hire/users/${id}/`
    ] as const;
    }


export const getHireUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireUsersRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireUsersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireUsersRetrieve>>> = ({ signal }) => hireUsersRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireUsersRetrieve>>>
export type HireUsersRetrieveQueryError = void


export function useHireUsersRetrieve<TData = Awaited<ReturnType<typeof hireUsersRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireUsersRetrieve<TData = Awaited<ReturnType<typeof hireUsersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireUsersRetrieve<TData = Awaited<ReturnType<typeof hireUsersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireUsersRetrieve<TData = Awaited<ReturnType<typeof hireUsersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireUsersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireUsersUpdateUrl = (id: number | 'me',) => {




  return `/api/hire/users/${id}/`
}

export const hireUsersUpdate = async (id: number | 'me',
    hireUserRequest: HireUserRequest, options?: Parameters<typeof customFetch>[1]): Promise<HireUser> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<HireUser>(getHireUsersUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(hireUserRequest)
  }
);}





export const getHireUsersUpdateMutationKey = () => ['hireUsersUpdate'] as const;

export const getHireUsersUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersUpdate>>, TError,HireUsersUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireUsersUpdate>>, TError,HireUsersUpdateMutationVariables, TContext> => {

const mutationKey = getHireUsersUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireUsersUpdate>>, HireUsersUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireUsersUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireUsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireUsersUpdate>>>
    export type HireUsersUpdateMutationBody = HireUserRequest
    export type HireUsersUpdateMutationError = void
    export type HireUsersUpdateMutationVariables = {id: number | 'me';data: HireUserRequest}

    export const useHireUsersUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersUpdate>>, TError,HireUsersUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireUsersUpdate>>,
        TError,
        HireUsersUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireUsersUpdateMutationOptions(options), queryClient);
    }
    export const getHireUsersPartialUpdateUrl = (id: number | 'me',) => {




  return `/api/hire/users/${id}/`
}

export const hireUsersPartialUpdate = async (id: number | 'me',
    patchedHireUserRequest?: PatchedHireUserRequest, options?: Parameters<typeof customFetch>[1]): Promise<HireUser> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<HireUser>(getHireUsersPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedHireUserRequest)
  }
);}





export const getHireUsersPartialUpdateMutationKey = () => ['hireUsersPartialUpdate'] as const;

export const getHireUsersPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersPartialUpdate>>, TError,HireUsersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireUsersPartialUpdate>>, TError,HireUsersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireUsersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireUsersPartialUpdate>>, HireUsersPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  hireUsersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireUsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireUsersPartialUpdate>>>
    export type HireUsersPartialUpdateMutationBody = PatchedHireUserRequest | undefined
    export type HireUsersPartialUpdateMutationError = void
    export type HireUsersPartialUpdateMutationVariables = {id: number | 'me';data?: PatchedHireUserRequest}

    export const useHireUsersPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireUsersPartialUpdate>>, TError,HireUsersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireUsersPartialUpdate>>,
        TError,
        HireUsersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireUsersPartialUpdateMutationOptions(options), queryClient);
    }
